import {
  Companion_getInstance17fcxlkqs50ig as Companion_getInstance,
  FormSize383y0pj5845uy as FormSize,
} from './helpers.mjs';
import { PrimitiveClasses_getInstance2v63zn04dtq03 as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import {
  arrayOf1akklvh2at202 as arrayOf,
  toString30pk9tzaqopn as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  createKType31ecntyyaay3k as createKType,
  createInvariantKTypeProjection3h5364czc0a8w as createInvariantKTypeProjection,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializer1i4e9ym37oxmo as serializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
  Char19o2r8palgjof as Char,
  toString3o7ifthqydp6e as toString_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  substringBefore3n7kj60w69hju as substringBefore,
  substringAfterLast3r0t0my8cpqhk as substringAfterLast,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { titleCasej01kvzva6qlf as titleCase } from '../../casing.mjs';
import {
  Unit_instance1fbcbse1fwigr as Unit_instance,
  Unitkvevlwgzwiuc as Unit,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  EmailAddress1n0o8cqqfp9qz as EmailAddress,
  PhoneNumber2x98iurnwvnj9 as PhoneNumber,
  _EmailAddress___get_raw__impl__6ose21hsaqj8b5ou10 as _EmailAddress___get_raw__impl__6ose2,
  toEmailAddress2ffkb20dbp5nk as toEmailAddress,
  _EmailAddress___get_url__impl__h7wdun3iqx1gt6bapgk as _EmailAddress___get_url__impl__h7wdun,
  _PhoneNumber___get_raw__impl__gc2pmp2lry17e31ba5a as _PhoneNumber___get_raw__impl__gc2pmp,
  toPhoneNumber24bmj59aego07 as toPhoneNumber,
  _PhoneNumber___get_url__impl__12igm036eb90tuqn2ei as _PhoneNumber___get_url__impl__12igm0,
} from '../../../../../lightning-server-shared/com/lightningkite/StringAlts.mjs';
import {
  TimeZone3oibfp0mqo4lg as TimeZone,
  Companion_getInstance3qu5ydsg8audm as Companion_getInstance_0,
  toLocalDateTime3u4c8ydzr4ubp as toLocalDateTime,
  toInstant2q17i3aluy6ks as toInstant,
} from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/TimeZone.mjs';
import { GeoCoordinatemhej4memzolm as GeoCoordinate } from '../../../../../lightning-server-shared/com/lightningkite/GeoCoordinate.mjs';
import { UUIDSerializer_getInstance2ms0oa88en0c as UUIDSerializer_getInstance } from '../../../../../lightning-server-shared/com/lightningkite/serialization/Serializers.mjs';
import {
  UUID21wrnrlmk5y1y as UUID,
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_1,
} from '../../../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { LocalDateTime3vqv9moe7clf4 as LocalDateTime } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDateTime.mjs';
import { LocalDate31mqn6zavbpi8 as LocalDate } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import { LocalTime22kisvxz6f9p4 as LocalTime } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalTime.mjs';
import {
  Temperature20f98n8g5dacx as Temperature,
  _Temperature___get_fahrenheit__impl__xao1tu3k07fe8wpsxj7 as _Temperature___get_fahrenheit__impl__xao1tu,
  _Temperature___get_celsius__impl__lhbsrw20893twwx7n3g as _Temperature___get_celsius__impl__lhbsrw,
  Companion_instance17glu83oz0rte as Companion_instance,
} from '../../../../../lightning-server-shared/com/lightningkite/usefulTypes.mjs';
import { Conditionuclxcm24fzd9 as Condition } from '../../../../../lightning-server-shared/com/lightningkite/lightningdb/Condition.mjs';
import {
  HorizontalListRenderer_getInstance2a2d2yjt2ymkp as HorizontalListRenderer_getInstance,
  VerticalListRenderer_getInstance4zt7v1o9ou4j as VerticalListRenderer_getInstance,
  HorizontalSetRenderer_getInstance3gkefggjyyvww as HorizontalSetRenderer_getInstance,
  VerticalSetRenderer_getInstance3io8tjnf253ym as VerticalSetRenderer_getInstance,
} from './ListRenderer.mjs';
import {
  Generator2kgtccb0jt0mi as Generator,
  Generator1qrulkrel7e5m as Generator_0,
  Companion_instance17v8p6g2424o4 as Companion_instance_0,
  FormSelector1zdq40oqbcvms as FormSelector,
  ViewRenderer1i6kznnbg7y21 as ViewRenderer,
  get_kind27kjvyfnc9an8 as get_kind,
  priority7vn90mx06311 as priority,
  matches2uu672wulv59r as matches,
  Companion_instancegwok6qx7et5m as Companion_instance_1,
  FormRendererv0cfjgipxuxv as FormRenderer,
  get_handlesField2upaii4zzjnxm as get_handlesField,
} from './FormRenderer.mjs';
import { PathPartsRenderer_getInstance2ime2nh4qzqap as PathPartsRenderer_getInstance } from './PathPartsRenderer.mjs';
import { SortPathRenderer_getInstance11nnv6lt4yoa7 as SortPathRenderer_getInstance } from './SortPathRenderer.mjs';
import { ToStringRenderer_instancei1qkyx3isyzf as ToStringRenderer_instance } from './ToStringRenderer.mjs';
import { EnumFormRenderer_getInstance168is7m1qimls as EnumFormRenderer_getInstance } from './EnumFormRenderer.mjs';
import { ByFieldRenderer_getInstancew6mhcnruubzr as ByFieldRenderer_getInstance } from './ByFieldRenderer.mjs';
import { NullableFormRenderer_instance2fo3dccdjw01o as NullableFormRenderer_instance } from './NullableFormRenderer.mjs';
import { ObjectRenderer_getInstance1bejzlvzrz2au as ObjectRenderer_getInstance } from './ObjectRenderer.mjs';
import { WrapperViewRenderer_instance1rgnfqet7vbtz as WrapperViewRenderer_instance } from './WrapperViewRenderer.mjs';
import { WrapperFormRenderer_instance2ibtnpuvgr7bz as WrapperFormRenderer_instance } from './WrapperFormRenderer.mjs';
import { MySealedFormRenderer_getInstance3eio0tqn0zjx4 as MySealedFormRenderer_getInstance } from './MySealedFormRenderer.mjs';
import { JsonRenderer_getInstanceck93e7fofwux as JsonRenderer_getInstance } from './JsonRenderer.mjs';
import { ServerFileRenderer_instancerzww5z0kqvmd as ServerFileRenderer_instance } from './ServerFileRenderer.mjs';
import { TableRenderer_getInstance1laavxqxr29w3 as TableRenderer_getInstance } from './TableRenderer.mjs';
import { ForeignKeyRenderer_instance2lj28oaf1gant as ForeignKeyRenderer_instance } from './ForeignKeyRenderer.mjs';
import { InlineFormRenderer_getInstance1ts6ggnqmxq4m as InlineFormRenderer_getInstance } from './InlineFormRenderer.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_centered1xfu6or5nc0lq as get_centered,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { NumberInput16nzuc28fuw7p as NumberInput } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/NumberField.commonHtml.mjs';
import {
  Align_End_getInstance1wccjuzcldlk8 as Align_End_getInstance,
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance_2,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  withWritedlio9p0oewet as withWrite,
  nullable1jpwknw8t4llm as nullable,
} from '../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { get_descriptionOrDisplayName2lozlddigjs1n as get_descriptionOrDisplayName } from './annotationReaders.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { get_nonNullOriginal9jr56l6mleb8 as get_nonNullOriginal } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString_1,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Checkbox2he0oy51inwu6 as Checkbox } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Checkbox.commonHtml.mjs';
import { text1v7b2bj2gx49v as text } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  numberToInt1ygmcfwhs2fkq as numberToInt,
  toByte4i43936u611k as toByte,
  toShort36kaw0zjdq3ex as toShort,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import {
  toNumber2e2hj9zugjwi2 as toNumber,
  numberToLong2pakxeg38estk as numberToLong,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import {
  toString1h6jjoch8cjt8 as toString_2,
  toString28s61jeiy4rb0 as toString_3,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import {
  toByteOrNull1g10huah4g6wb as toByteOrNull,
  toShortOrNull1ebh3grvoo0rv as toShortOrNull,
  toIntOrNull1j8dcc6to13o4 as toIntOrNull,
  toLongOrNull12l1gfztrukv1 as toLongOrNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringNumberConversions.mjs';
import { firstOrNulltrxqttxfxqju as firstOrNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { IntValue8ydihstvmcr7 as IntValue } from '../../../../../lightning-server-shared/com/lightningkite/serialization/VirtualType.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { TextArea6va0jt1dj0tc as TextArea } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextArea.commonHtml.mjs';
import {
  errorTextv58wi1t0me7u as errorText,
  icon1sxjaie5w1apt as icon,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { ExternalLink3fl954ixvn5zt as ExternalLink } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ExternalLink.commonHtml.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { listOfvhqybd2zx248 as listOf_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { plus310ted5e4i90h as plus } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  LocalDateTimeField29gd1oxpr4f6s as LocalDateTimeField,
  LocalDateField1854369auhx0q as LocalDateField,
  LocalTimeField1c574dxc0ggzd as LocalTimeField,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LocalDateTimeField.commonHtml.mjs';
import { renderToString1atd3jbop96tk as renderToString } from '../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.mjs';
import {
  renderToString20fhv3rgk9b94 as renderToString_0,
  renderToString2kyj9dlz89tdi as renderToString_1,
  renderToString1ghq9c47uw4e8 as renderToString_2,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.js.mjs';
import { awaitqeg6zusi9ora as await_0 } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { Reactive1jy75v4li6ldv as Reactive } from '../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function defaults(_this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.forms.viewForTypeWithField' call
  var size = Companion_getInstance().jdu_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_0 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_1 = serializer(this_0, createKType(PrimitiveClasses_getInstance().yf(), arrayOf([]), false));
  var serializer_0 = isInterface(this_1, KSerializer()) ? this_1 : THROW_CCE();
  var name = (serializer_0.az().l11() ? 'Optional ' : '') + titleCase(substringAfterLast(substringBefore(serializer_0.az().h10(), _Char___init__impl__6a9atx(47)), _Char___init__impl__6a9atx(46)));
  _this__u8e3s4.ldx(new (defaults$$inlined$viewForTypeWithField$1())(null, serializer_0, name, 1.0, size));
  // Inline function 'com.lightningkite.kiteui.forms.viewForTypeWithField' call
  var size_0 = Companion_getInstance().jdu_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_2 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_3 = serializer(this_2, createKType(PrimitiveClasses_getInstance().yf(), arrayOf([]), true));
  var serializer_1 = isInterface(this_3, KSerializer()) ? this_3 : THROW_CCE();
  var name_0 = (serializer_1.az().l11() ? 'Optional ' : '') + titleCase(substringAfterLast(substringBefore(serializer_1.az().h10(), _Char___init__impl__6a9atx(47)), _Char___init__impl__6a9atx(46)));
  _this__u8e3s4.ldx(new (defaults$$inlined$viewForTypeWithField$2())(null, serializer_1, name_0, 1.0, size_0));
  // Inline function 'com.lightningkite.kiteui.forms.formForTypeWithField' call
  var size_1 = Companion_getInstance().jdu_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_4 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_5 = serializer(this_4, createKType(PrimitiveClasses_getInstance().yf(), arrayOf([]), false));
  var serializer_2 = isInterface(this_5, KSerializer()) ? this_5 : THROW_CCE();
  var name_1 = (serializer_2.az().l11() ? 'Optional ' : '') + titleCase(substringAfterLast(substringBefore(serializer_2.az().h10(), _Char___init__impl__6a9atx(47)), _Char___init__impl__6a9atx(46)));
  _this__u8e3s4.kdx(new (defaults$$inlined$formForTypeWithField$1())(null, serializer_2, name_1, 1.0, size_1));
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var size_2 = Companion_getInstance().jdu_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_6 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_7 = serializer(this_6, createKType(PrimitiveClasses_getInstance().yf(), arrayOf([]), true));
  var serializer_3 = isInterface(this_7, KSerializer()) ? this_7 : THROW_CCE();
  var name_2 = (serializer_3.az().l11() ? 'Optional ' : '') + titleCase(substringAfterLast(substringBefore(serializer_3.az().h10(), _Char___init__impl__6a9atx(47)), _Char___init__impl__6a9atx(46)));
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$1())(null, serializer_3, name_2, 1.0, size_2));
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var size_3 = Companion_getInstance().jdu_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_8 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_9 = serializer(this_8, createKType(PrimitiveClasses_getInstance().zf(), arrayOf([]), true));
  var serializer_4 = isInterface(this_9, KSerializer()) ? this_9 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$2())(null, serializer_4, 'Number', 1.0, size_3));
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var size_4 = Companion_getInstance().jdu_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_10 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_11 = serializer(this_10, createKType(PrimitiveClasses_getInstance().ag(), arrayOf([]), true));
  var serializer_5 = isInterface(this_11, KSerializer()) ? this_11 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$3())(null, serializer_5, 'Number', 1.0, size_4));
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var size_5 = Companion_getInstance().jdu_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_12 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_13 = serializer(this_12, createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), true));
  var serializer_6 = isInterface(this_13, KSerializer()) ? this_13 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$4())(null, serializer_6, 'Number', 1.0, size_5));
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var size_6 = Companion_getInstance().jdu_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_14 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_15 = serializer(this_14, createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), true));
  var serializer_7 = isInterface(this_15, KSerializer()) ? this_15 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$5())(null, serializer_7, 'Number', 1.0, size_6));
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var size_7 = Companion_getInstance().jdu_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_16 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_17 = serializer(this_16, createKType(PrimitiveClasses_getInstance().zf(), arrayOf([]), false));
  var serializer_8 = isInterface(this_17, KSerializer()) ? this_17 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$6())(null, serializer_8, 'Number', 1.0, size_7));
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var size_8 = Companion_getInstance().jdu_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_18 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_19 = serializer(this_18, createKType(PrimitiveClasses_getInstance().ag(), arrayOf([]), false));
  var serializer_9 = isInterface(this_19, KSerializer()) ? this_19 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$7())(null, serializer_9, 'Number', 1.0, size_8));
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var size_9 = Companion_getInstance().jdu_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_20 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_21 = serializer(this_20, createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false));
  var serializer_10 = isInterface(this_21, KSerializer()) ? this_21 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$8())(null, serializer_10, 'Number', 1.0, size_9));
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var size_10 = Companion_getInstance().jdu_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_22 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_23 = serializer(this_22, createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false));
  var serializer_11 = isInterface(this_23, KSerializer()) ? this_23 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$9())(null, serializer_11, 'Number', 1.0, size_10));
  var tmp2 = Companion_getInstance().jdu_1;
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var name_3 = 'Hexadecimal';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_24 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_25 = serializer(this_24, createKType(PrimitiveClasses_getInstance().zf(), arrayOf([]), true));
  var serializer_12 = isInterface(this_25, KSerializer()) ? this_25 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$10())(null, serializer_12, name_3, 0.9, tmp2));
  var tmp2_0 = Companion_getInstance().jdu_1;
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var name_4 = 'Hexadecimal';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_26 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_27 = serializer(this_26, createKType(PrimitiveClasses_getInstance().ag(), arrayOf([]), true));
  var serializer_13 = isInterface(this_27, KSerializer()) ? this_27 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$11())(null, serializer_13, name_4, 0.9, tmp2_0));
  var tmp2_1 = Companion_getInstance().jdu_1;
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var name_5 = 'Hexadecimal';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_28 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_29 = serializer(this_28, createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), true));
  var serializer_14 = isInterface(this_29, KSerializer()) ? this_29 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$12())(null, serializer_14, name_5, 0.9, tmp2_1));
  var tmp2_2 = Companion_getInstance().jdu_1;
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var name_6 = 'Hexadecimal';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_30 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_31 = serializer(this_30, createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), true));
  var serializer_15 = isInterface(this_31, KSerializer()) ? this_31 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$13())(null, serializer_15, name_6, 0.9, tmp2_2));
  var tmp2_3 = Companion_getInstance().jdu_1;
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var name_7 = 'Hexadecimal';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_32 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_33 = serializer(this_32, createKType(PrimitiveClasses_getInstance().zf(), arrayOf([]), false));
  var serializer_16 = isInterface(this_33, KSerializer()) ? this_33 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$14())(null, serializer_16, name_7, 0.9, tmp2_3));
  var tmp2_4 = Companion_getInstance().jdu_1;
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var name_8 = 'Hexadecimal';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_34 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_35 = serializer(this_34, createKType(PrimitiveClasses_getInstance().ag(), arrayOf([]), false));
  var serializer_17 = isInterface(this_35, KSerializer()) ? this_35 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$15())(null, serializer_17, name_8, 0.9, tmp2_4));
  var tmp2_5 = Companion_getInstance().jdu_1;
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var name_9 = 'Hexadecimal';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_36 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_37 = serializer(this_36, createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false));
  var serializer_18 = isInterface(this_37, KSerializer()) ? this_37 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$16())(null, serializer_18, name_9, 0.9, tmp2_5));
  var tmp2_6 = Companion_getInstance().jdu_1;
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var name_10 = 'Hexadecimal';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_38 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_39 = serializer(this_38, createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false));
  var serializer_19 = isInterface(this_39, KSerializer()) ? this_39 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$17())(null, serializer_19, name_10, 0.9, tmp2_6));
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var size_11 = Companion_getInstance().jdu_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_40 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_41 = serializer(this_40, createKType(PrimitiveClasses_getInstance().zf(), arrayOf([]), true));
  var serializer_20 = isInterface(this_41, KSerializer()) ? this_41 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$18())(null, serializer_20, 'Binary', 0.8, size_11));
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var size_12 = Companion_getInstance().jdu_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_42 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_43 = serializer(this_42, createKType(PrimitiveClasses_getInstance().ag(), arrayOf([]), true));
  var serializer_21 = isInterface(this_43, KSerializer()) ? this_43 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$19())(null, serializer_21, 'Binary', 0.8, size_12));
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var size_13 = Companion_getInstance().jdu_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_44 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_45 = serializer(this_44, createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), true));
  var serializer_22 = isInterface(this_45, KSerializer()) ? this_45 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$20())(null, serializer_22, 'Binary', 0.8, size_13));
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var size_14 = Companion_getInstance().jdu_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_46 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_47 = serializer(this_46, createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), true));
  var serializer_23 = isInterface(this_47, KSerializer()) ? this_47 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$21())(null, serializer_23, 'Binary', 0.8, size_14));
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var size_15 = Companion_getInstance().jdu_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_48 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_49 = serializer(this_48, createKType(PrimitiveClasses_getInstance().zf(), arrayOf([]), false));
  var serializer_24 = isInterface(this_49, KSerializer()) ? this_49 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$22())(null, serializer_24, 'Binary', 0.8, size_15));
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var size_16 = Companion_getInstance().jdu_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_50 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_51 = serializer(this_50, createKType(PrimitiveClasses_getInstance().ag(), arrayOf([]), false));
  var serializer_25 = isInterface(this_51, KSerializer()) ? this_51 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$23())(null, serializer_25, 'Binary', 0.8, size_16));
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var size_17 = Companion_getInstance().jdu_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_52 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_53 = serializer(this_52, createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false));
  var serializer_26 = isInterface(this_53, KSerializer()) ? this_53 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$24())(null, serializer_26, 'Binary', 0.8, size_17));
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var size_18 = Companion_getInstance().jdu_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_54 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_55 = serializer(this_54, createKType(PrimitiveClasses_getInstance().cg(), arrayOf([]), false));
  var serializer_27 = isInterface(this_55, KSerializer()) ? this_55 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$25())(null, serializer_27, 'Binary', 0.8, size_18));
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var size_19 = Companion_getInstance().jdu_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_56 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_57 = serializer(this_56, createKType(PrimitiveClasses_getInstance().dg(), arrayOf([]), true));
  var serializer_28 = isInterface(this_57, KSerializer()) ? this_57 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$26())(null, serializer_28, 'Number', 1.0, size_19));
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var size_20 = Companion_getInstance().jdu_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_58 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_59 = serializer(this_58, createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), true));
  var serializer_29 = isInterface(this_59, KSerializer()) ? this_59 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$27())(null, serializer_29, 'Number', 1.0, size_20));
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var size_21 = Companion_getInstance().jdu_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_60 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_61 = serializer(this_60, createKType(PrimitiveClasses_getInstance().dg(), arrayOf([]), false));
  var serializer_30 = isInterface(this_61, KSerializer()) ? this_61 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$28())(null, serializer_30, 'Number', 1.0, size_21));
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var size_22 = Companion_getInstance().jdu_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_62 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_63 = serializer(this_62, createKType(PrimitiveClasses_getInstance().eg(), arrayOf([]), false));
  var serializer_31 = isInterface(this_63, KSerializer()) ? this_63 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$29())(null, serializer_31, 'Number', 1.0, size_22));
  var tmp2_7 = Companion_getInstance().jdu_1;
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var name_11 = 'Character';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_64 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_65 = serializer(this_64, createKType(getKClass(Char()), arrayOf([]), false));
  var serializer_32 = isInterface(this_65, KSerializer()) ? this_65 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$30())(null, serializer_32, name_11, 1.0, tmp2_7));
  var tmp2_8 = Companion_getInstance().jdu_1;
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var name_12 = 'Character';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_66 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_67 = serializer(this_66, createKType(getKClass(Char()), arrayOf([]), true));
  var serializer_33 = isInterface(this_67, KSerializer()) ? this_67 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$31())(null, serializer_33, name_12, 1.0, tmp2_8));
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  // Inline function 'kotlinx.serialization.serializer' call
  var this_68 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_69 = serializer(this_68, createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), false));
  var serializer_34 = isInterface(this_69, KSerializer()) ? this_69 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$32())(null, serializer_34, 'Text', 1.0));
  // Inline function 'com.lightningkite.kiteui.forms.viewForType' call
  // Inline function 'kotlinx.serialization.serializer' call
  var this_70 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_71 = serializer(this_70, createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), false));
  var serializer_35 = isInterface(this_71, KSerializer()) ? this_71 : THROW_CCE();
  _this__u8e3s4.ldx(new (defaults$$inlined$viewForType$1())(null, serializer_35, 'Text', 1.0));
  var tmp2_9 = new (FormSize())(40.0, 10.0);
  var tmp4 = 'Large Text';
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var annotation = 'com.lightningkite.lightningdb.Multiline';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_72 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_73 = serializer(this_72, createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), false));
  var serializer_36 = isInterface(this_73, KSerializer()) ? this_73 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$33())(annotation, serializer_36, tmp4, 2.0, tmp2_9));
  var tmp2_10 = new (FormSize())(40.0, 3.0);
  var tmp4_0 = 'Large Text Summary';
  // Inline function 'com.lightningkite.kiteui.forms.viewForType' call
  var annotation_0 = 'com.lightningkite.lightningdb.Multiline';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_74 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_75 = serializer(this_74, createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), false));
  var serializer_37 = isInterface(this_75, KSerializer()) ? this_75 : THROW_CCE();
  _this__u8e3s4.ldx(new (defaults$$inlined$viewForType$2())(annotation_0, serializer_37, tmp4_0, 0.8, tmp2_10));
  var tmp2_11 = new (FormSize())(40.0, 10.0);
  var tmp4_1 = 'Large Text';
  // Inline function 'com.lightningkite.kiteui.forms.viewForType' call
  var annotation_1 = 'com.lightningkite.lightningdb.Multiline';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_76 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_77 = serializer(this_76, createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), false));
  var serializer_38 = isInterface(this_77, KSerializer()) ? this_77 : THROW_CCE();
  _this__u8e3s4.ldx(new (defaults$$inlined$viewForType$3())(annotation_1, serializer_38, tmp4_1, 0.8, tmp2_11));
  var tmp2_12 = new (FormSize())(20.0, 1.0);
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var name_13 = 'Email Address';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_78 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_79 = serializer(this_78, createKType(getKClass(EmailAddress()), arrayOf([]), false));
  var serializer_39 = isInterface(this_79, KSerializer()) ? this_79 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$34())(null, serializer_39, name_13, 1.0, tmp2_12));
  var tmp2_13 = new (FormSize())(20.0, 1.0);
  // Inline function 'com.lightningkite.kiteui.forms.viewForType' call
  var name_14 = 'Email Address';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_80 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_81 = serializer(this_80, createKType(getKClass(EmailAddress()), arrayOf([]), false));
  var serializer_40 = isInterface(this_81, KSerializer()) ? this_81 : THROW_CCE();
  _this__u8e3s4.ldx(new (defaults$$inlined$viewForType$4())(null, serializer_40, name_14, 1.0, tmp2_13));
  var tmp2_14 = new (FormSize())(20.0, 1.0);
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var name_15 = 'Phone Number';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_82 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_83 = serializer(this_82, createKType(getKClass(PhoneNumber()), arrayOf([]), false));
  var serializer_41 = isInterface(this_83, KSerializer()) ? this_83 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$35())(null, serializer_41, name_15, 1.0, tmp2_14));
  var tmp2_15 = new (FormSize())(20.0, 1.0);
  // Inline function 'com.lightningkite.kiteui.forms.viewForType' call
  var name_16 = 'Phone Number';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_84 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_85 = serializer(this_84, createKType(getKClass(PhoneNumber()), arrayOf([]), false));
  var serializer_42 = isInterface(this_85, KSerializer()) ? this_85 : THROW_CCE();
  _this__u8e3s4.ldx(new (defaults$$inlined$viewForType$5())(null, serializer_42, name_16, 1.0, tmp2_15));
  var tmp2_16 = new (FormSize())(20.0, 1.0);
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var name_17 = 'Time Zone';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_86 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_87 = serializer(this_86, createKType(getKClass(TimeZone()), arrayOf([]), false));
  var serializer_43 = isInterface(this_87, KSerializer()) ? this_87 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$36())(null, serializer_43, name_17, 1.0, tmp2_16));
  var tmp2_17 = new (FormSize())(20.0, 1.0);
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var name_18 = 'Time Zone';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_88 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_89 = serializer(this_88, createKType(getKClass(TimeZone()), arrayOf([]), true));
  var serializer_44 = isInterface(this_89, KSerializer()) ? this_89 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$37())(null, serializer_44, name_18, 1.0, tmp2_17));
  var tmp2_18 = new (FormSize())(20.0, 1.0);
  // Inline function 'com.lightningkite.kiteui.forms.viewForType' call
  var name_19 = 'Geocoordinate - Direct Entry';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_90 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_91 = serializer(this_90, createKType(getKClass(GeoCoordinate()), arrayOf([]), false));
  var serializer_45 = isInterface(this_91, KSerializer()) ? this_91 : THROW_CCE();
  _this__u8e3s4.ldx(new (defaults$$inlined$viewForType$6())(null, serializer_45, name_19, 1.0, tmp2_18));
  var tmp2_19 = new (FormSize())(20.0, 1.0);
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var name_20 = 'Geocoordinate - Direct Entry';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_92 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_93 = serializer(this_92, createKType(getKClass(GeoCoordinate()), arrayOf([]), false));
  var serializer_46 = isInterface(this_93, KSerializer()) ? this_93 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$38())(null, serializer_46, name_20, 1.0, tmp2_19));
  var tmp2_20 = new (FormSize())(24.0, 1.0);
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var serializer_47 = UUIDSerializer_getInstance();
  var name_21 = (serializer_47.az().l11() ? 'Optional ' : '') + titleCase(substringAfterLast(substringBefore(serializer_47.az().h10(), _Char___init__impl__6a9atx(47)), _Char___init__impl__6a9atx(46)));
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$39())(null, serializer_47, name_21, 1.0, tmp2_20));
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var size_23 = new (FormSize())(24.0, 1.0);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_94 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_95 = serializer(this_94, createKType(getKClass(UUID()), arrayOf([]), false));
  var serializer_48 = isInterface(this_95, KSerializer()) ? this_95 : THROW_CCE();
  var name_22 = (serializer_48.az().l11() ? 'Optional ' : '') + titleCase(substringAfterLast(substringBefore(serializer_48.az().h10(), _Char___init__impl__6a9atx(47)), _Char___init__impl__6a9atx(46)));
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$40())(null, serializer_48, name_22, 1.0, size_23));
  var tmp2_21 = new (FormSize())(24.0, 1.0);
  // Inline function 'com.lightningkite.kiteui.forms.viewForType' call
  var serializer_49 = UUIDSerializer_getInstance();
  var name_23 = (serializer_49.az().l11() ? 'Optional ' : '') + titleCase(substringAfterLast(substringBefore(serializer_49.az().h10(), _Char___init__impl__6a9atx(47)), _Char___init__impl__6a9atx(46)));
  _this__u8e3s4.ldx(new (defaults$$inlined$viewForType$7())(null, serializer_49, name_23, 1.0, tmp2_21));
  // Inline function 'com.lightningkite.kiteui.forms.viewForType' call
  var size_24 = new (FormSize())(24.0, 1.0);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_96 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_97 = serializer(this_96, createKType(getKClass(UUID()), arrayOf([]), false));
  var serializer_50 = isInterface(this_97, KSerializer()) ? this_97 : THROW_CCE();
  var name_24 = (serializer_50.az().l11() ? 'Optional ' : '') + titleCase(substringAfterLast(substringBefore(serializer_50.az().h10(), _Char___init__impl__6a9atx(47)), _Char___init__impl__6a9atx(46)));
  _this__u8e3s4.ldx(new (defaults$$inlined$viewForType$8())(null, serializer_50, name_24, 1.0, size_24));
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var size_25 = Companion_getInstance().jdu_1;
  // Inline function 'kotlinx.serialization.serializer' call
  var this_98 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_99 = serializer(this_98, createKType(getKClass(KtMap()), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Unit()), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit()), arrayOf([]), false))]), false));
  var serializer_51 = isInterface(this_99, KSerializer()) ? this_99 : THROW_CCE();
  var name_25 = (serializer_51.az().l11() ? 'Optional ' : '') + titleCase(substringAfterLast(substringBefore(serializer_51.az().h10(), _Char___init__impl__6a9atx(47)), _Char___init__impl__6a9atx(46)));
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$41())(null, serializer_51, name_25, 1.0, size_25));
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var size_26 = new (FormSize())(17.0, 1.0);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_100 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_101 = serializer(this_100, createKType(getKClass(Instant()), arrayOf([]), false));
  var serializer_52 = isInterface(this_101, KSerializer()) ? this_101 : THROW_CCE();
  var name_26 = (serializer_52.az().l11() ? 'Optional ' : '') + titleCase(substringAfterLast(substringBefore(serializer_52.az().h10(), _Char___init__impl__6a9atx(47)), _Char___init__impl__6a9atx(46)));
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$42())(null, serializer_52, name_26, 1.0, size_26));
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var size_27 = new (FormSize())(17.0, 1.0);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_102 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_103 = serializer(this_102, createKType(getKClass(Instant()), arrayOf([]), true));
  var serializer_53 = isInterface(this_103, KSerializer()) ? this_103 : THROW_CCE();
  var name_27 = (serializer_53.az().l11() ? 'Optional ' : '') + titleCase(substringAfterLast(substringBefore(serializer_53.az().h10(), _Char___init__impl__6a9atx(47)), _Char___init__impl__6a9atx(46)));
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$43())(null, serializer_53, name_27, 1.0, size_27));
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var size_28 = new (FormSize())(17.0, 1.0);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_104 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_105 = serializer(this_104, createKType(getKClass(LocalDateTime()), arrayOf([]), false));
  var serializer_54 = isInterface(this_105, KSerializer()) ? this_105 : THROW_CCE();
  var name_28 = (serializer_54.az().l11() ? 'Optional ' : '') + titleCase(substringAfterLast(substringBefore(serializer_54.az().h10(), _Char___init__impl__6a9atx(47)), _Char___init__impl__6a9atx(46)));
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$44())(null, serializer_54, name_28, 1.0, size_28));
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var size_29 = new (FormSize())(17.0, 1.0);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_106 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_107 = serializer(this_106, createKType(getKClass(LocalDateTime()), arrayOf([]), true));
  var serializer_55 = isInterface(this_107, KSerializer()) ? this_107 : THROW_CCE();
  var name_29 = (serializer_55.az().l11() ? 'Optional ' : '') + titleCase(substringAfterLast(substringBefore(serializer_55.az().h10(), _Char___init__impl__6a9atx(47)), _Char___init__impl__6a9atx(46)));
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$45())(null, serializer_55, name_29, 1.0, size_29));
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var size_30 = new (FormSize())(11.0, 1.0);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_108 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_109 = serializer(this_108, createKType(getKClass(LocalDate()), arrayOf([]), false));
  var serializer_56 = isInterface(this_109, KSerializer()) ? this_109 : THROW_CCE();
  var name_30 = (serializer_56.az().l11() ? 'Optional ' : '') + titleCase(substringAfterLast(substringBefore(serializer_56.az().h10(), _Char___init__impl__6a9atx(47)), _Char___init__impl__6a9atx(46)));
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$46())(null, serializer_56, name_30, 1.0, size_30));
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var size_31 = new (FormSize())(12.0, 1.0);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_110 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_111 = serializer(this_110, createKType(getKClass(LocalDate()), arrayOf([]), true));
  var serializer_57 = isInterface(this_111, KSerializer()) ? this_111 : THROW_CCE();
  var name_31 = (serializer_57.az().l11() ? 'Optional ' : '') + titleCase(substringAfterLast(substringBefore(serializer_57.az().h10(), _Char___init__impl__6a9atx(47)), _Char___init__impl__6a9atx(46)));
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$47())(null, serializer_57, name_31, 1.0, size_31));
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var size_32 = new (FormSize())(5.0, 1.0);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_112 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_113 = serializer(this_112, createKType(getKClass(LocalTime()), arrayOf([]), false));
  var serializer_58 = isInterface(this_113, KSerializer()) ? this_113 : THROW_CCE();
  var name_32 = (serializer_58.az().l11() ? 'Optional ' : '') + titleCase(substringAfterLast(substringBefore(serializer_58.az().h10(), _Char___init__impl__6a9atx(47)), _Char___init__impl__6a9atx(46)));
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$48())(null, serializer_58, name_32, 1.0, size_32));
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var size_33 = new (FormSize())(5.0, 1.0);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_114 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_115 = serializer(this_114, createKType(getKClass(LocalTime()), arrayOf([]), true));
  var serializer_59 = isInterface(this_115, KSerializer()) ? this_115 : THROW_CCE();
  var name_33 = (serializer_59.az().l11() ? 'Optional ' : '') + titleCase(substringAfterLast(substringBefore(serializer_59.az().h10(), _Char___init__impl__6a9atx(47)), _Char___init__impl__6a9atx(46)));
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$49())(null, serializer_59, name_33, 1.0, size_33));
  // Inline function 'com.lightningkite.kiteui.forms.viewForType' call
  var size_34 = new (FormSize())(17.0, 1.0);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_116 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_117 = serializer(this_116, createKType(getKClass(Instant()), arrayOf([]), false));
  var serializer_60 = isInterface(this_117, KSerializer()) ? this_117 : THROW_CCE();
  var name_34 = (serializer_60.az().l11() ? 'Optional ' : '') + titleCase(substringAfterLast(substringBefore(serializer_60.az().h10(), _Char___init__impl__6a9atx(47)), _Char___init__impl__6a9atx(46)));
  _this__u8e3s4.ldx(new (defaults$$inlined$viewForType$9())(null, serializer_60, name_34, 1.0, size_34));
  // Inline function 'com.lightningkite.kiteui.forms.viewForType' call
  var size_35 = new (FormSize())(17.0, 1.0);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_118 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_119 = serializer(this_118, createKType(getKClass(LocalDateTime()), arrayOf([]), false));
  var serializer_61 = isInterface(this_119, KSerializer()) ? this_119 : THROW_CCE();
  var name_35 = (serializer_61.az().l11() ? 'Optional ' : '') + titleCase(substringAfterLast(substringBefore(serializer_61.az().h10(), _Char___init__impl__6a9atx(47)), _Char___init__impl__6a9atx(46)));
  _this__u8e3s4.ldx(new (defaults$$inlined$viewForType$10())(null, serializer_61, name_35, 1.0, size_35));
  // Inline function 'com.lightningkite.kiteui.forms.viewForType' call
  var size_36 = new (FormSize())(12.0, 1.0);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_120 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_121 = serializer(this_120, createKType(getKClass(LocalDate()), arrayOf([]), false));
  var serializer_62 = isInterface(this_121, KSerializer()) ? this_121 : THROW_CCE();
  var name_36 = (serializer_62.az().l11() ? 'Optional ' : '') + titleCase(substringAfterLast(substringBefore(serializer_62.az().h10(), _Char___init__impl__6a9atx(47)), _Char___init__impl__6a9atx(46)));
  _this__u8e3s4.ldx(new (defaults$$inlined$viewForType$11())(null, serializer_62, name_36, 1.0, size_36));
  // Inline function 'com.lightningkite.kiteui.forms.viewForType' call
  var size_37 = new (FormSize())(5.0, 1.0);
  // Inline function 'kotlinx.serialization.serializer' call
  var this_122 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_123 = serializer(this_122, createKType(getKClass(LocalTime()), arrayOf([]), false));
  var serializer_63 = isInterface(this_123, KSerializer()) ? this_123 : THROW_CCE();
  var name_37 = (serializer_63.az().l11() ? 'Optional ' : '') + titleCase(substringAfterLast(substringBefore(serializer_63.az().h10(), _Char___init__impl__6a9atx(47)), _Char___init__impl__6a9atx(46)));
  _this__u8e3s4.ldx(new (defaults$$inlined$viewForType$12())(null, serializer_63, name_37, 1.0, size_37));
  var tmp2_22 = Companion_getInstance().jdu_1;
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var name_38 = 'Temperature';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_124 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_125 = serializer(this_124, createKType(getKClass(Temperature()), arrayOf([]), true));
  var serializer_64 = isInterface(this_125, KSerializer()) ? this_125 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$50())(null, serializer_64, name_38, 1.0, tmp2_22));
  var tmp2_23 = Companion_getInstance().jdu_1;
  // Inline function 'com.lightningkite.kiteui.forms.formForType' call
  var name_39 = 'Temperature';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_126 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_127 = serializer(this_126, createKType(getKClass(Temperature()), arrayOf([]), false));
  var serializer_65 = isInterface(this_127, KSerializer()) ? this_127 : THROW_CCE();
  _this__u8e3s4.kdx(new (defaults$$inlined$formForType$51())(null, serializer_65, name_39, 1.0, tmp2_23));
  var tmp2_24 = Companion_getInstance().jdu_1;
  // Inline function 'com.lightningkite.kiteui.forms.viewForType' call
  var name_40 = 'Programmer-y Text';
  // Inline function 'kotlinx.serialization.serializer' call
  var this_128 = _this__u8e3s4.hdt_1;
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_129 = serializer(this_128, createKType(getKClass(Condition()), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().bg(), arrayOf([]), false))]), false));
  var serializer_66 = isInterface(this_129, KSerializer()) ? this_129 : THROW_CCE();
  _this__u8e3s4.ldx(new (defaults$$inlined$viewForType$13())(null, serializer_66, name_40, 1.0, tmp2_24));
  var tmp = HorizontalListRenderer_getInstance();
  _this__u8e3s4.kdx(isInterface(tmp, Generator()) ? tmp : THROW_CCE());
  var tmp_0 = HorizontalListRenderer_getInstance();
  _this__u8e3s4.ldx(isInterface(tmp_0, Generator_0()) ? tmp_0 : THROW_CCE());
  var tmp_1 = VerticalListRenderer_getInstance();
  _this__u8e3s4.kdx(isInterface(tmp_1, Generator()) ? tmp_1 : THROW_CCE());
  var tmp_2 = VerticalListRenderer_getInstance();
  _this__u8e3s4.ldx(isInterface(tmp_2, Generator_0()) ? tmp_2 : THROW_CCE());
  var tmp_3 = HorizontalSetRenderer_getInstance();
  _this__u8e3s4.kdx(isInterface(tmp_3, Generator()) ? tmp_3 : THROW_CCE());
  var tmp_4 = HorizontalSetRenderer_getInstance();
  _this__u8e3s4.ldx(isInterface(tmp_4, Generator_0()) ? tmp_4 : THROW_CCE());
  var tmp_5 = VerticalSetRenderer_getInstance();
  _this__u8e3s4.kdx(isInterface(tmp_5, Generator()) ? tmp_5 : THROW_CCE());
  var tmp_6 = VerticalSetRenderer_getInstance();
  _this__u8e3s4.ldx(isInterface(tmp_6, Generator_0()) ? tmp_6 : THROW_CCE());
  _this__u8e3s4.kdx(PathPartsRenderer_getInstance());
  var tmp_7 = SortPathRenderer_getInstance();
  _this__u8e3s4.kdx(isInterface(tmp_7, Generator()) ? tmp_7 : THROW_CCE());
  var tmp_8 = SortPathRenderer_getInstance();
  _this__u8e3s4.ldx(isInterface(tmp_8, Generator_0()) ? tmp_8 : THROW_CCE());
  _this__u8e3s4.ldx(ToStringRenderer_instance);
  var tmp_9 = EnumFormRenderer_getInstance();
  _this__u8e3s4.kdx(isInterface(tmp_9, Generator()) ? tmp_9 : THROW_CCE());
  var tmp_10 = EnumFormRenderer_getInstance();
  _this__u8e3s4.ldx(isInterface(tmp_10, Generator_0()) ? tmp_10 : THROW_CCE());
  var tmp_11 = ByFieldRenderer_getInstance();
  _this__u8e3s4.kdx(isInterface(tmp_11, Generator()) ? tmp_11 : THROW_CCE());
  var tmp_12 = ByFieldRenderer_getInstance();
  _this__u8e3s4.ldx(isInterface(tmp_12, Generator_0()) ? tmp_12 : THROW_CCE());
  var tmp_13 = NullableFormRenderer_instance;
  _this__u8e3s4.kdx(isInterface(tmp_13, Generator()) ? tmp_13 : THROW_CCE());
  var tmp_14 = NullableFormRenderer_instance;
  _this__u8e3s4.ldx(isInterface(tmp_14, Generator_0()) ? tmp_14 : THROW_CCE());
  var tmp_15 = ObjectRenderer_getInstance();
  _this__u8e3s4.kdx(isInterface(tmp_15, Generator()) ? tmp_15 : THROW_CCE());
  var tmp_16 = ObjectRenderer_getInstance();
  _this__u8e3s4.ldx(isInterface(tmp_16, Generator_0()) ? tmp_16 : THROW_CCE());
  _this__u8e3s4.ldx(WrapperViewRenderer_instance);
  _this__u8e3s4.kdx(WrapperFormRenderer_instance);
  _this__u8e3s4.kdx(MySealedFormRenderer_getInstance());
  var tmp_17 = JsonRenderer_getInstance();
  _this__u8e3s4.kdx(isInterface(tmp_17, Generator()) ? tmp_17 : THROW_CCE());
  var tmp_18 = JsonRenderer_getInstance();
  _this__u8e3s4.ldx(isInterface(tmp_18, Generator_0()) ? tmp_18 : THROW_CCE());
  var tmp_19 = ServerFileRenderer_instance;
  _this__u8e3s4.kdx(isInterface(tmp_19, Generator()) ? tmp_19 : THROW_CCE());
  var tmp_20 = ServerFileRenderer_instance;
  _this__u8e3s4.ldx(isInterface(tmp_20, Generator_0()) ? tmp_20 : THROW_CCE());
  var tmp_21 = TableRenderer_getInstance();
  _this__u8e3s4.kdx(isInterface(tmp_21, Generator()) ? tmp_21 : THROW_CCE());
  var tmp_22 = TableRenderer_getInstance();
  _this__u8e3s4.ldx(isInterface(tmp_22, Generator_0()) ? tmp_22 : THROW_CCE());
  var tmp_23 = ForeignKeyRenderer_instance;
  _this__u8e3s4.kdx(isInterface(tmp_23, Generator()) ? tmp_23 : THROW_CCE());
  var tmp_24 = ForeignKeyRenderer_instance;
  _this__u8e3s4.ldx(isInterface(tmp_24, Generator_0()) ? tmp_24 : THROW_CCE());
  var tmp_25 = InlineFormRenderer_getInstance();
  _this__u8e3s4.kdx(isInterface(tmp_25, Generator()) ? tmp_25 : THROW_CCE());
  var tmp_26 = InlineFormRenderer_getInstance();
  _this__u8e3s4.ldx(isInterface(tmp_26, Generator_0()) ? tmp_26 : THROW_CCE());
}
function defaults$temperatureInput(_this__u8e3s4, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(false);
  var celsius = Signal().fak(false);
  var tmp = get_expanding(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (NumberInput())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.bbs(Align_End_getInstance());
  var tmp_0 = remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp;
    if ($this$remember.baj(celsius)) {
      var tmp_0 = $this$remember.baj(mutable);
      var tmp0_safe_receiver = tmp_0 == null ? null : tmp_0.q4w_1;
      var tmp_1;
      var tmp_2 = tmp0_safe_receiver;
      if ((tmp_2 == null ? null : new (Temperature())(tmp_2)) == null) {
        tmp_1 = null;
      } else {
        tmp_1 = _Temperature___get_celsius__impl__lhbsrw(tmp0_safe_receiver);
      }
      tmp = tmp_1;
    } else {
      var tmp_3 = $this$remember.baj(mutable);
      var tmp1_safe_receiver = tmp_3 == null ? null : tmp_3.q4w_1;
      var tmp_4;
      var tmp_5 = tmp1_safe_receiver;
      if ((tmp_5 == null ? null : new (Temperature())(tmp_5)) == null) {
        tmp_4 = null;
      } else {
        tmp_4 = _Temperature___get_fahrenheit__impl__xao1tu(tmp1_safe_receiver);
      }
      tmp = tmp_4;
    }
    return tmp;
  });
  view_0.xah(view_0.xc5_1, withWrite(tmp_0, defaults$temperatureInput$slambda_0(mutable, celsius)));
  view.fbb(p_0, view_0);
  view.jbb(tmp, view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.select' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Select())(view.pc());
  var tmp0_elvis_lhs_1 = view.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.ebb(p_1, view_1);
  var tmp_1 = _Constant___init__impl__v45mub(listOf([true, false]));
  view_1.mcf(celsius, new (Constant())(tmp_1), defaults$temperatureInput$lambda);
  view.fbb(p_1, view_1);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function defaults$o$view$lambda($this$ViewRenderer, field, readable) {
  var field_0 = field;
  var it = readable;
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())($this$ViewRenderer.pc());
  var tmp0_elvis_lhs = $this$ViewRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$ViewRenderer : tmp0_elvis_lhs;
  $this$ViewRenderer.ebb(p, view);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var tmp;
    if ($this$reactiveScope.baj(it)) {
      var tmp0_safe_receiver = field_0;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : get_descriptionOrDisplayName(tmp0_safe_receiver);
      tmp = '\u2713 ' + (tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
    } else {
      var tmp2_safe_receiver = field_0;
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : get_descriptionOrDisplayName(tmp2_safe_receiver);
      tmp = '\u2718 ' + (tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs);
    }
    var tmp$ret$0 = tmp;
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  $this$ViewRenderer.fbb(p, view);
  return view;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var defaults$$inlined$viewForTypeWithField$1Class;
function defaults$$inlined$viewForTypeWithField$1() {
  if (defaults$$inlined$viewForTypeWithField$1Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.ye1_1 = $size;
        this.se1_1 = $annotation;
        this.te1_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.ue1_1 = $serializer.az().l11();
        this.ve1_1 = $name;
        this.we1_1 = $priority;
        this.xe1_1 = true;
      }
      qdu() {
        return this.se1_1;
      }
      f94() {
        return this.te1_1;
      }
      pdu() {
        return this.ue1_1;
      }
      k20() {
        return this.ve1_1;
      }
      cdu() {
        return this.we1_1;
      }
      idu(module_0, selector) {
        return this.ye1_1;
      }
      ndu(module_0, selector) {
        var tmp = Companion_instance_0;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.odu(module_0, this, tmp_0, VOID, VOID, defaults$o$view$lambda);
        return isInterface(tmp_1, ViewRenderer()) ? tmp_1 : THROW_CCE();
      }
      uds() {
        return this.xe1_1;
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator_0()]);
    defaults$$inlined$viewForTypeWithField$1Class = $;
  }
  return defaults$$inlined$viewForTypeWithField$1Class;
}
function defaults$o$view$lambda_0($this$ViewRenderer, field, readable) {
  var field_0 = field;
  var it = readable;
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())($this$ViewRenderer.pc());
  var tmp0_elvis_lhs = $this$ViewRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$ViewRenderer : tmp0_elvis_lhs;
  $this$ViewRenderer.ebb(p, view);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl_0(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_0(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var tmp;
    switch ($this$reactiveScope.baj(it)) {
      case true:
        var tmp1_safe_receiver = field_0;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : get_descriptionOrDisplayName(tmp1_safe_receiver);
        tmp = '\u2713 ' + (tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs);
        break;
      case false:
        var tmp3_safe_receiver = field_0;
        var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : get_descriptionOrDisplayName(tmp3_safe_receiver);
        tmp = '\u2718 ' + (tmp4_elvis_lhs == null ? '' : tmp4_elvis_lhs);
        break;
      case null:
        var tmp5_safe_receiver = field_0;
        var tmp6_elvis_lhs = tmp5_safe_receiver == null ? null : get_descriptionOrDisplayName(tmp5_safe_receiver);
        tmp = '- ' + (tmp6_elvis_lhs == null ? '' : tmp6_elvis_lhs);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var tmp$ret$0 = tmp;
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  $this$ViewRenderer.fbb(p, view);
  return view;
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var defaults$$inlined$viewForTypeWithField$2Class;
function defaults$$inlined$viewForTypeWithField$2() {
  if (defaults$$inlined$viewForTypeWithField$2Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.fe2_1 = $size;
        this.ze1_1 = $annotation;
        this.ae2_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.be2_1 = $serializer.az().l11();
        this.ce2_1 = $name;
        this.de2_1 = $priority;
        this.ee2_1 = true;
      }
      qdu() {
        return this.ze1_1;
      }
      f94() {
        return this.ae2_1;
      }
      pdu() {
        return this.be2_1;
      }
      k20() {
        return this.ce2_1;
      }
      cdu() {
        return this.de2_1;
      }
      idu(module_0, selector) {
        return this.fe2_1;
      }
      ndu(module_0, selector) {
        var tmp = Companion_instance_0;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.odu(module_0, this, tmp_0, VOID, VOID, defaults$o$view$lambda_0);
        return isInterface(tmp_1, ViewRenderer()) ? tmp_1 : THROW_CCE();
      }
      uds() {
        return this.ee2_1;
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator_0()]);
    defaults$$inlined$viewForTypeWithField$2Class = $;
  }
  return defaults$$inlined$viewForTypeWithField$2Class;
}
function defaults$o$form$lambda($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.xbm(false);
  var tmp = get_centered(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Checkbox())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xah(view_0.cbk_1, mutable);
  view.fbb(p_0, view_0);
  view.jbb(tmp, view_0);
  var tmp1_safe_receiver = field == null ? null : get_descriptionOrDisplayName(field);
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    view.jbb(get_centered(view), text(view, tmp1_safe_receiver));
  }
  $this$FormRenderer.fbb(p, view);
  return view;
}
var defaults$$inlined$formForTypeWithField$1Class;
function defaults$$inlined$formForTypeWithField$1() {
  if (defaults$$inlined$formForTypeWithField$1Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.me2_1 = $size;
        this.ge2_1 = $annotation;
        this.he2_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.ie2_1 = $serializer.az().l11();
        this.je2_1 = $name;
        this.ke2_1 = $priority;
        this.le2_1 = true;
      }
      qdu() {
        return this.ge2_1;
      }
      f94() {
        return this.he2_1;
      }
      pdu() {
        return this.ie2_1;
      }
      k20() {
        return this.je2_1;
      }
      cdu() {
        return this.ke2_1;
      }
      idu(module_0, selector) {
        return this.me2_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
      uds() {
        return this.le2_1;
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForTypeWithField$1Class = $;
  }
  return defaults$$inlined$formForTypeWithField$1Class;
}
function defaults$o$form$lambda_0($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.direct.select' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Select())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  var tmp = _Constant___init__impl__v45mub(listOf([null, true, false]));
  view.mcf(mutable, new (Constant())(tmp), defaults$o$form$lambda$lambda);
  $this$FormRenderer.fbb(p, view);
  return view;
}
function defaults$o$form$lambda$lambda(it) {
  var tmp;
  switch (it) {
    case true:
      tmp = 'Yes';
      break;
    case false:
      tmp = 'No';
      break;
    case null:
      tmp = 'N/A';
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
var defaults$$inlined$formForType$1Class;
function defaults$$inlined$formForType$1() {
  if (defaults$$inlined$formForType$1Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.se2_1 = $size;
        this.ne2_1 = $annotation;
        this.oe2_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.pe2_1 = $serializer.az().l11();
        this.qe2_1 = $name;
        this.re2_1 = $priority;
      }
      qdu() {
        return this.ne2_1;
      }
      f94() {
        return this.oe2_1;
      }
      pdu() {
        return this.pe2_1;
      }
      k20() {
        return this.qe2_1;
      }
      cdu() {
        return this.re2_1;
      }
      idu(module_0, selector) {
        return this.se2_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_0);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$1Class = $;
  }
  return defaults$$inlined$formForType$1Class;
}
function defaults$o$form$lambda_1($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (NumberInput())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.bbs(Align_End_getInstance());
  var tmp_0 = defaults$o$form$lambda$lambda_0;
  view.xah(view.xc5_1, mutable.tak(tmp_0, defaults$o$form$lambda$lambda_1));
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_0(it) {
  return it == null ? null : it;
}
function defaults$o$form$lambda$lambda_1(it) {
  var tmp1_safe_receiver = it == null ? null : numberToInt(it);
  return tmp1_safe_receiver == null ? null : toByte(tmp1_safe_receiver);
}
var defaults$$inlined$formForType$2Class;
function defaults$$inlined$formForType$2() {
  if (defaults$$inlined$formForType$2Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.ye2_1 = $size;
        this.te2_1 = $annotation;
        this.ue2_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.ve2_1 = $serializer.az().l11();
        this.we2_1 = $name;
        this.xe2_1 = $priority;
      }
      qdu() {
        return this.te2_1;
      }
      f94() {
        return this.ue2_1;
      }
      pdu() {
        return this.ve2_1;
      }
      k20() {
        return this.we2_1;
      }
      cdu() {
        return this.xe2_1;
      }
      idu(module_0, selector) {
        return this.ye2_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_1);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$2Class = $;
  }
  return defaults$$inlined$formForType$2Class;
}
function defaults$o$form$lambda_2($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (NumberInput())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.bbs(Align_End_getInstance());
  var tmp_0 = defaults$o$form$lambda$lambda_2;
  view.xah(view.xc5_1, mutable.tak(tmp_0, defaults$o$form$lambda$lambda_3));
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_2(it) {
  return it == null ? null : it;
}
function defaults$o$form$lambda$lambda_3(it) {
  var tmp1_safe_receiver = it == null ? null : numberToInt(it);
  return tmp1_safe_receiver == null ? null : toShort(tmp1_safe_receiver);
}
var defaults$$inlined$formForType$3Class;
function defaults$$inlined$formForType$3() {
  if (defaults$$inlined$formForType$3Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.ee3_1 = $size;
        this.ze2_1 = $annotation;
        this.ae3_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.be3_1 = $serializer.az().l11();
        this.ce3_1 = $name;
        this.de3_1 = $priority;
      }
      qdu() {
        return this.ze2_1;
      }
      f94() {
        return this.ae3_1;
      }
      pdu() {
        return this.be3_1;
      }
      k20() {
        return this.ce3_1;
      }
      cdu() {
        return this.de3_1;
      }
      idu(module_0, selector) {
        return this.ee3_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_2);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$3Class = $;
  }
  return defaults$$inlined$formForType$3Class;
}
function defaults$o$form$lambda_3($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (NumberInput())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.bbs(Align_End_getInstance());
  var tmp_0 = defaults$o$form$lambda$lambda_4;
  view.xah(view.xc5_1, mutable.tak(tmp_0, defaults$o$form$lambda$lambda_5));
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_4(it) {
  return it == null ? null : it;
}
function defaults$o$form$lambda$lambda_5(it) {
  return it == null ? null : numberToInt(it);
}
var defaults$$inlined$formForType$4Class;
function defaults$$inlined$formForType$4() {
  if (defaults$$inlined$formForType$4Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.ke3_1 = $size;
        this.fe3_1 = $annotation;
        this.ge3_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.he3_1 = $serializer.az().l11();
        this.ie3_1 = $name;
        this.je3_1 = $priority;
      }
      qdu() {
        return this.fe3_1;
      }
      f94() {
        return this.ge3_1;
      }
      pdu() {
        return this.he3_1;
      }
      k20() {
        return this.ie3_1;
      }
      cdu() {
        return this.je3_1;
      }
      idu(module_0, selector) {
        return this.ke3_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_3);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$4Class = $;
  }
  return defaults$$inlined$formForType$4Class;
}
function defaults$o$form$lambda_4($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (NumberInput())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.bbs(Align_End_getInstance());
  var tmp_0 = defaults$o$form$lambda$lambda_6;
  view.xah(view.xc5_1, mutable.tak(tmp_0, defaults$o$form$lambda$lambda_7));
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_6(it) {
  return it == null ? null : toNumber(it);
}
function defaults$o$form$lambda$lambda_7(it) {
  return it == null ? null : numberToLong(it);
}
var defaults$$inlined$formForType$5Class;
function defaults$$inlined$formForType$5() {
  if (defaults$$inlined$formForType$5Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.qe3_1 = $size;
        this.le3_1 = $annotation;
        this.me3_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.ne3_1 = $serializer.az().l11();
        this.oe3_1 = $name;
        this.pe3_1 = $priority;
      }
      qdu() {
        return this.le3_1;
      }
      f94() {
        return this.me3_1;
      }
      pdu() {
        return this.ne3_1;
      }
      k20() {
        return this.oe3_1;
      }
      cdu() {
        return this.pe3_1;
      }
      idu(module_0, selector) {
        return this.qe3_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_4);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$5Class = $;
  }
  return defaults$$inlined$formForType$5Class;
}
function defaults$o$form$lambda_5($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (NumberInput())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.bbs(Align_End_getInstance());
  var tmp_0 = defaults$o$form$lambda$lambda_8;
  view.xah(view.xc5_1, mutable.bak(tmp_0, defaults$o$form$lambda$lambda_9));
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_8(it) {
  return it;
}
function defaults$o$form$lambda$lambda_9(o, it) {
  var tmp1_safe_receiver = it == null ? null : numberToInt(it);
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : toByte(tmp1_safe_receiver);
  return tmp2_elvis_lhs == null ? o : tmp2_elvis_lhs;
}
var defaults$$inlined$formForType$6Class;
function defaults$$inlined$formForType$6() {
  if (defaults$$inlined$formForType$6Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.we3_1 = $size;
        this.re3_1 = $annotation;
        this.se3_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.te3_1 = $serializer.az().l11();
        this.ue3_1 = $name;
        this.ve3_1 = $priority;
      }
      qdu() {
        return this.re3_1;
      }
      f94() {
        return this.se3_1;
      }
      pdu() {
        return this.te3_1;
      }
      k20() {
        return this.ue3_1;
      }
      cdu() {
        return this.ve3_1;
      }
      idu(module_0, selector) {
        return this.we3_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_5);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$6Class = $;
  }
  return defaults$$inlined$formForType$6Class;
}
function defaults$o$form$lambda_6($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (NumberInput())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.bbs(Align_End_getInstance());
  var tmp_0 = defaults$o$form$lambda$lambda_10;
  view.xah(view.xc5_1, mutable.bak(tmp_0, defaults$o$form$lambda$lambda_11));
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_10(it) {
  return it;
}
function defaults$o$form$lambda$lambda_11(o, it) {
  var tmp1_safe_receiver = it == null ? null : numberToInt(it);
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : toShort(tmp1_safe_receiver);
  return tmp2_elvis_lhs == null ? o : tmp2_elvis_lhs;
}
var defaults$$inlined$formForType$7Class;
function defaults$$inlined$formForType$7() {
  if (defaults$$inlined$formForType$7Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.ce4_1 = $size;
        this.xe3_1 = $annotation;
        this.ye3_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.ze3_1 = $serializer.az().l11();
        this.ae4_1 = $name;
        this.be4_1 = $priority;
      }
      qdu() {
        return this.xe3_1;
      }
      f94() {
        return this.ye3_1;
      }
      pdu() {
        return this.ze3_1;
      }
      k20() {
        return this.ae4_1;
      }
      cdu() {
        return this.be4_1;
      }
      idu(module_0, selector) {
        return this.ce4_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_6);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$7Class = $;
  }
  return defaults$$inlined$formForType$7Class;
}
function defaults$o$form$lambda_7($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (NumberInput())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.bbs(Align_End_getInstance());
  var tmp_0 = defaults$o$form$lambda$lambda_12;
  view.xah(view.xc5_1, mutable.bak(tmp_0, defaults$o$form$lambda$lambda_13));
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_12(it) {
  return it;
}
function defaults$o$form$lambda$lambda_13(o, it) {
  var tmp1_elvis_lhs = it == null ? null : numberToInt(it);
  return tmp1_elvis_lhs == null ? o : tmp1_elvis_lhs;
}
var defaults$$inlined$formForType$8Class;
function defaults$$inlined$formForType$8() {
  if (defaults$$inlined$formForType$8Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.ie4_1 = $size;
        this.de4_1 = $annotation;
        this.ee4_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.fe4_1 = $serializer.az().l11();
        this.ge4_1 = $name;
        this.he4_1 = $priority;
      }
      qdu() {
        return this.de4_1;
      }
      f94() {
        return this.ee4_1;
      }
      pdu() {
        return this.fe4_1;
      }
      k20() {
        return this.ge4_1;
      }
      cdu() {
        return this.he4_1;
      }
      idu(module_0, selector) {
        return this.ie4_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_7);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$8Class = $;
  }
  return defaults$$inlined$formForType$8Class;
}
function defaults$o$form$lambda_8($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (NumberInput())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.bbs(Align_End_getInstance());
  var tmp_0 = defaults$o$form$lambda$lambda_14;
  view.xah(view.xc5_1, mutable.bak(tmp_0, defaults$o$form$lambda$lambda_15));
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_14(it) {
  return toNumber(it);
}
function defaults$o$form$lambda$lambda_15(o, it) {
  var tmp1_elvis_lhs = it == null ? null : numberToLong(it);
  return tmp1_elvis_lhs == null ? o : tmp1_elvis_lhs;
}
var defaults$$inlined$formForType$9Class;
function defaults$$inlined$formForType$9() {
  if (defaults$$inlined$formForType$9Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.oe4_1 = $size;
        this.je4_1 = $annotation;
        this.ke4_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.le4_1 = $serializer.az().l11();
        this.me4_1 = $name;
        this.ne4_1 = $priority;
      }
      qdu() {
        return this.je4_1;
      }
      f94() {
        return this.ke4_1;
      }
      pdu() {
        return this.le4_1;
      }
      k20() {
        return this.me4_1;
      }
      cdu() {
        return this.ne4_1;
      }
      idu(module_0, selector) {
        return this.oe4_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_8);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$9Class = $;
  }
  return defaults$$inlined$formForType$9Class;
}
function defaults$o$form$lambda_9($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextInput())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.bbs(Align_End_getInstance());
  var tmp_0 = defaults$o$form$lambda$lambda_16;
  view.xah(view.gcn_1, mutable.tak(tmp_0, defaults$o$form$lambda$lambda_17));
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_16(it) {
  var tmp;
  if (it == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.text.toString' call
    tmp = toString_2(it, 16);
  }
  var tmp1_elvis_lhs = tmp;
  return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
}
function defaults$o$form$lambda$lambda_17(it) {
  return it == null ? null : toByteOrNull(it, 16);
}
var defaults$$inlined$formForType$10Class;
function defaults$$inlined$formForType$10() {
  if (defaults$$inlined$formForType$10Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.ue4_1 = $size;
        this.pe4_1 = $annotation;
        this.qe4_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.re4_1 = $serializer.az().l11();
        this.se4_1 = $name;
        this.te4_1 = $priority;
      }
      qdu() {
        return this.pe4_1;
      }
      f94() {
        return this.qe4_1;
      }
      pdu() {
        return this.re4_1;
      }
      k20() {
        return this.se4_1;
      }
      cdu() {
        return this.te4_1;
      }
      idu(module_0, selector) {
        return this.ue4_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_9);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$10Class = $;
  }
  return defaults$$inlined$formForType$10Class;
}
function defaults$o$form$lambda_10($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextInput())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.bbs(Align_End_getInstance());
  var tmp_0 = defaults$o$form$lambda$lambda_18;
  view.xah(view.gcn_1, mutable.tak(tmp_0, defaults$o$form$lambda$lambda_19));
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_18(it) {
  var tmp;
  if (it == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.text.toString' call
    tmp = toString_2(it, 16);
  }
  var tmp1_elvis_lhs = tmp;
  return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
}
function defaults$o$form$lambda$lambda_19(it) {
  return it == null ? null : toShortOrNull(it, 16);
}
var defaults$$inlined$formForType$11Class;
function defaults$$inlined$formForType$11() {
  if (defaults$$inlined$formForType$11Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.ae5_1 = $size;
        this.ve4_1 = $annotation;
        this.we4_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.xe4_1 = $serializer.az().l11();
        this.ye4_1 = $name;
        this.ze4_1 = $priority;
      }
      qdu() {
        return this.ve4_1;
      }
      f94() {
        return this.we4_1;
      }
      pdu() {
        return this.xe4_1;
      }
      k20() {
        return this.ye4_1;
      }
      cdu() {
        return this.ze4_1;
      }
      idu(module_0, selector) {
        return this.ae5_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_10);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$11Class = $;
  }
  return defaults$$inlined$formForType$11Class;
}
function defaults$o$form$lambda_11($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextInput())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.bbs(Align_End_getInstance());
  var tmp_0 = defaults$o$form$lambda$lambda_20;
  view.xah(view.gcn_1, mutable.tak(tmp_0, defaults$o$form$lambda$lambda_21));
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_20(it) {
  var tmp1_elvis_lhs = it == null ? null : toString_2(it, 16);
  return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
}
function defaults$o$form$lambda$lambda_21(it) {
  return it == null ? null : toIntOrNull(it, 16);
}
var defaults$$inlined$formForType$12Class;
function defaults$$inlined$formForType$12() {
  if (defaults$$inlined$formForType$12Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.ge5_1 = $size;
        this.be5_1 = $annotation;
        this.ce5_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.de5_1 = $serializer.az().l11();
        this.ee5_1 = $name;
        this.fe5_1 = $priority;
      }
      qdu() {
        return this.be5_1;
      }
      f94() {
        return this.ce5_1;
      }
      pdu() {
        return this.de5_1;
      }
      k20() {
        return this.ee5_1;
      }
      cdu() {
        return this.fe5_1;
      }
      idu(module_0, selector) {
        return this.ge5_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_11);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$12Class = $;
  }
  return defaults$$inlined$formForType$12Class;
}
function defaults$o$form$lambda_12($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextInput())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.bbs(Align_End_getInstance());
  var tmp_0 = defaults$o$form$lambda$lambda_22;
  view.xah(view.gcn_1, mutable.tak(tmp_0, defaults$o$form$lambda$lambda_23));
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_22(it) {
  var tmp1_elvis_lhs = it == null ? null : toString_3(it, 16);
  return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
}
function defaults$o$form$lambda$lambda_23(it) {
  return it == null ? null : toLongOrNull(it, 16);
}
var defaults$$inlined$formForType$13Class;
function defaults$$inlined$formForType$13() {
  if (defaults$$inlined$formForType$13Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.me5_1 = $size;
        this.he5_1 = $annotation;
        this.ie5_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.je5_1 = $serializer.az().l11();
        this.ke5_1 = $name;
        this.le5_1 = $priority;
      }
      qdu() {
        return this.he5_1;
      }
      f94() {
        return this.ie5_1;
      }
      pdu() {
        return this.je5_1;
      }
      k20() {
        return this.ke5_1;
      }
      cdu() {
        return this.le5_1;
      }
      idu(module_0, selector) {
        return this.me5_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_12);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$13Class = $;
  }
  return defaults$$inlined$formForType$13Class;
}
function defaults$o$form$lambda_13($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextInput())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.bbs(Align_End_getInstance());
  var tmp_0 = defaults$o$form$lambda$lambda_24;
  view.xah(view.gcn_1, mutable.bak(tmp_0, defaults$o$form$lambda$lambda_25));
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_24(it) {
  // Inline function 'kotlin.text.toString' call
  return toString_2(it, 16);
}
function defaults$o$form$lambda$lambda_25(o, it) {
  var tmp1_elvis_lhs = it == null ? null : toByteOrNull(it, 16);
  return tmp1_elvis_lhs == null ? o : tmp1_elvis_lhs;
}
var defaults$$inlined$formForType$14Class;
function defaults$$inlined$formForType$14() {
  if (defaults$$inlined$formForType$14Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.se5_1 = $size;
        this.ne5_1 = $annotation;
        this.oe5_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.pe5_1 = $serializer.az().l11();
        this.qe5_1 = $name;
        this.re5_1 = $priority;
      }
      qdu() {
        return this.ne5_1;
      }
      f94() {
        return this.oe5_1;
      }
      pdu() {
        return this.pe5_1;
      }
      k20() {
        return this.qe5_1;
      }
      cdu() {
        return this.re5_1;
      }
      idu(module_0, selector) {
        return this.se5_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_13);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$14Class = $;
  }
  return defaults$$inlined$formForType$14Class;
}
function defaults$o$form$lambda_14($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextInput())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.bbs(Align_End_getInstance());
  var tmp_0 = defaults$o$form$lambda$lambda_26;
  view.xah(view.gcn_1, mutable.bak(tmp_0, defaults$o$form$lambda$lambda_27));
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_26(it) {
  // Inline function 'kotlin.text.toString' call
  return toString_2(it, 16);
}
function defaults$o$form$lambda$lambda_27(o, it) {
  var tmp1_elvis_lhs = it == null ? null : toShortOrNull(it, 16);
  return tmp1_elvis_lhs == null ? o : tmp1_elvis_lhs;
}
var defaults$$inlined$formForType$15Class;
function defaults$$inlined$formForType$15() {
  if (defaults$$inlined$formForType$15Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.ye5_1 = $size;
        this.te5_1 = $annotation;
        this.ue5_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.ve5_1 = $serializer.az().l11();
        this.we5_1 = $name;
        this.xe5_1 = $priority;
      }
      qdu() {
        return this.te5_1;
      }
      f94() {
        return this.ue5_1;
      }
      pdu() {
        return this.ve5_1;
      }
      k20() {
        return this.we5_1;
      }
      cdu() {
        return this.xe5_1;
      }
      idu(module_0, selector) {
        return this.ye5_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_14);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$15Class = $;
  }
  return defaults$$inlined$formForType$15Class;
}
function defaults$o$form$lambda_15($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextInput())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.bbs(Align_End_getInstance());
  var tmp_0 = defaults$o$form$lambda$lambda_28;
  view.xah(view.gcn_1, mutable.bak(tmp_0, defaults$o$form$lambda$lambda_29));
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_28(it) {
  return toString_2(it, 16);
}
function defaults$o$form$lambda$lambda_29(o, it) {
  var tmp1_elvis_lhs = it == null ? null : toIntOrNull(it, 16);
  return tmp1_elvis_lhs == null ? o : tmp1_elvis_lhs;
}
var defaults$$inlined$formForType$16Class;
function defaults$$inlined$formForType$16() {
  if (defaults$$inlined$formForType$16Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.ee6_1 = $size;
        this.ze5_1 = $annotation;
        this.ae6_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.be6_1 = $serializer.az().l11();
        this.ce6_1 = $name;
        this.de6_1 = $priority;
      }
      qdu() {
        return this.ze5_1;
      }
      f94() {
        return this.ae6_1;
      }
      pdu() {
        return this.be6_1;
      }
      k20() {
        return this.ce6_1;
      }
      cdu() {
        return this.de6_1;
      }
      idu(module_0, selector) {
        return this.ee6_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_15);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$16Class = $;
  }
  return defaults$$inlined$formForType$16Class;
}
function defaults$o$form$lambda_16($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextInput())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.bbs(Align_End_getInstance());
  var tmp_0 = defaults$o$form$lambda$lambda_30;
  view.xah(view.gcn_1, mutable.bak(tmp_0, defaults$o$form$lambda$lambda_31));
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_30(it) {
  return toString_3(it, 16);
}
function defaults$o$form$lambda$lambda_31(o, it) {
  var tmp1_elvis_lhs = it == null ? null : toLongOrNull(it, 16);
  return tmp1_elvis_lhs == null ? o : tmp1_elvis_lhs;
}
var defaults$$inlined$formForType$17Class;
function defaults$$inlined$formForType$17() {
  if (defaults$$inlined$formForType$17Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.ke6_1 = $size;
        this.fe6_1 = $annotation;
        this.ge6_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.he6_1 = $serializer.az().l11();
        this.ie6_1 = $name;
        this.je6_1 = $priority;
      }
      qdu() {
        return this.fe6_1;
      }
      f94() {
        return this.ge6_1;
      }
      pdu() {
        return this.he6_1;
      }
      k20() {
        return this.ie6_1;
      }
      cdu() {
        return this.je6_1;
      }
      idu(module_0, selector) {
        return this.ke6_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_16);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$17Class = $;
  }
  return defaults$$inlined$formForType$17Class;
}
function defaults$o$form$lambda_17($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextInput())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.bbs(Align_End_getInstance());
  var tmp_0 = defaults$o$form$lambda$lambda_32;
  view.xah(view.gcn_1, mutable.tak(tmp_0, defaults$o$form$lambda$lambda_33));
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_32(it) {
  var tmp;
  if (it == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.text.toString' call
    tmp = toString_2(it, 2);
  }
  var tmp1_elvis_lhs = tmp;
  return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
}
function defaults$o$form$lambda$lambda_33(it) {
  return it == null ? null : toByteOrNull(it, 2);
}
var defaults$$inlined$formForType$18Class;
function defaults$$inlined$formForType$18() {
  if (defaults$$inlined$formForType$18Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.qe6_1 = $size;
        this.le6_1 = $annotation;
        this.me6_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.ne6_1 = $serializer.az().l11();
        this.oe6_1 = $name;
        this.pe6_1 = $priority;
      }
      qdu() {
        return this.le6_1;
      }
      f94() {
        return this.me6_1;
      }
      pdu() {
        return this.ne6_1;
      }
      k20() {
        return this.oe6_1;
      }
      cdu() {
        return this.pe6_1;
      }
      idu(module_0, selector) {
        return this.qe6_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_17);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$18Class = $;
  }
  return defaults$$inlined$formForType$18Class;
}
function defaults$o$form$lambda_18($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextInput())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.bbs(Align_End_getInstance());
  var tmp_0 = defaults$o$form$lambda$lambda_34;
  view.xah(view.gcn_1, mutable.tak(tmp_0, defaults$o$form$lambda$lambda_35));
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_34(it) {
  var tmp;
  if (it == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.text.toString' call
    tmp = toString_2(it, 2);
  }
  var tmp1_elvis_lhs = tmp;
  return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
}
function defaults$o$form$lambda$lambda_35(it) {
  return it == null ? null : toShortOrNull(it, 2);
}
var defaults$$inlined$formForType$19Class;
function defaults$$inlined$formForType$19() {
  if (defaults$$inlined$formForType$19Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.we6_1 = $size;
        this.re6_1 = $annotation;
        this.se6_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.te6_1 = $serializer.az().l11();
        this.ue6_1 = $name;
        this.ve6_1 = $priority;
      }
      qdu() {
        return this.re6_1;
      }
      f94() {
        return this.se6_1;
      }
      pdu() {
        return this.te6_1;
      }
      k20() {
        return this.ue6_1;
      }
      cdu() {
        return this.ve6_1;
      }
      idu(module_0, selector) {
        return this.we6_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_18);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$19Class = $;
  }
  return defaults$$inlined$formForType$19Class;
}
function defaults$o$form$lambda_19($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextInput())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.bbs(Align_End_getInstance());
  var tmp_0 = defaults$o$form$lambda$lambda_36;
  view.xah(view.gcn_1, mutable.tak(tmp_0, defaults$o$form$lambda$lambda_37));
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_36(it) {
  var tmp1_elvis_lhs = it == null ? null : toString_2(it, 2);
  return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
}
function defaults$o$form$lambda$lambda_37(it) {
  return it == null ? null : toIntOrNull(it, 2);
}
var defaults$$inlined$formForType$20Class;
function defaults$$inlined$formForType$20() {
  if (defaults$$inlined$formForType$20Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.ce7_1 = $size;
        this.xe6_1 = $annotation;
        this.ye6_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.ze6_1 = $serializer.az().l11();
        this.ae7_1 = $name;
        this.be7_1 = $priority;
      }
      qdu() {
        return this.xe6_1;
      }
      f94() {
        return this.ye6_1;
      }
      pdu() {
        return this.ze6_1;
      }
      k20() {
        return this.ae7_1;
      }
      cdu() {
        return this.be7_1;
      }
      idu(module_0, selector) {
        return this.ce7_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_19);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$20Class = $;
  }
  return defaults$$inlined$formForType$20Class;
}
function defaults$o$form$lambda_20($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextInput())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.bbs(Align_End_getInstance());
  var tmp_0 = defaults$o$form$lambda$lambda_38;
  view.xah(view.gcn_1, mutable.tak(tmp_0, defaults$o$form$lambda$lambda_39));
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_38(it) {
  var tmp1_elvis_lhs = it == null ? null : toString_3(it, 2);
  return tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
}
function defaults$o$form$lambda$lambda_39(it) {
  return it == null ? null : toLongOrNull(it, 2);
}
var defaults$$inlined$formForType$21Class;
function defaults$$inlined$formForType$21() {
  if (defaults$$inlined$formForType$21Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.ie7_1 = $size;
        this.de7_1 = $annotation;
        this.ee7_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.fe7_1 = $serializer.az().l11();
        this.ge7_1 = $name;
        this.he7_1 = $priority;
      }
      qdu() {
        return this.de7_1;
      }
      f94() {
        return this.ee7_1;
      }
      pdu() {
        return this.fe7_1;
      }
      k20() {
        return this.ge7_1;
      }
      cdu() {
        return this.he7_1;
      }
      idu(module_0, selector) {
        return this.ie7_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_20);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$21Class = $;
  }
  return defaults$$inlined$formForType$21Class;
}
function defaults$o$form$lambda_21($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextInput())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.bbs(Align_End_getInstance());
  var tmp_0 = defaults$o$form$lambda$lambda_40;
  view.xah(view.gcn_1, mutable.bak(tmp_0, defaults$o$form$lambda$lambda_41));
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_40(it) {
  // Inline function 'kotlin.text.toString' call
  return toString_2(it, 2);
}
function defaults$o$form$lambda$lambda_41(o, it) {
  var tmp1_elvis_lhs = it == null ? null : toByteOrNull(it, 2);
  return tmp1_elvis_lhs == null ? o : tmp1_elvis_lhs;
}
var defaults$$inlined$formForType$22Class;
function defaults$$inlined$formForType$22() {
  if (defaults$$inlined$formForType$22Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.oe7_1 = $size;
        this.je7_1 = $annotation;
        this.ke7_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.le7_1 = $serializer.az().l11();
        this.me7_1 = $name;
        this.ne7_1 = $priority;
      }
      qdu() {
        return this.je7_1;
      }
      f94() {
        return this.ke7_1;
      }
      pdu() {
        return this.le7_1;
      }
      k20() {
        return this.me7_1;
      }
      cdu() {
        return this.ne7_1;
      }
      idu(module_0, selector) {
        return this.oe7_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_21);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$22Class = $;
  }
  return defaults$$inlined$formForType$22Class;
}
function defaults$o$form$lambda_22($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextInput())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.bbs(Align_End_getInstance());
  var tmp_0 = defaults$o$form$lambda$lambda_42;
  view.xah(view.gcn_1, mutable.bak(tmp_0, defaults$o$form$lambda$lambda_43));
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_42(it) {
  // Inline function 'kotlin.text.toString' call
  return toString_2(it, 2);
}
function defaults$o$form$lambda$lambda_43(o, it) {
  var tmp1_elvis_lhs = it == null ? null : toShortOrNull(it, 2);
  return tmp1_elvis_lhs == null ? o : tmp1_elvis_lhs;
}
var defaults$$inlined$formForType$23Class;
function defaults$$inlined$formForType$23() {
  if (defaults$$inlined$formForType$23Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.ue7_1 = $size;
        this.pe7_1 = $annotation;
        this.qe7_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.re7_1 = $serializer.az().l11();
        this.se7_1 = $name;
        this.te7_1 = $priority;
      }
      qdu() {
        return this.pe7_1;
      }
      f94() {
        return this.qe7_1;
      }
      pdu() {
        return this.re7_1;
      }
      k20() {
        return this.se7_1;
      }
      cdu() {
        return this.te7_1;
      }
      idu(module_0, selector) {
        return this.ue7_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_22);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$23Class = $;
  }
  return defaults$$inlined$formForType$23Class;
}
function defaults$o$form$lambda_23($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextInput())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.bbs(Align_End_getInstance());
  var tmp_0 = defaults$o$form$lambda$lambda_44;
  view.xah(view.gcn_1, mutable.bak(tmp_0, defaults$o$form$lambda$lambda_45));
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_44(it) {
  return toString_2(it, 2);
}
function defaults$o$form$lambda$lambda_45(o, it) {
  var tmp1_elvis_lhs = it == null ? null : toIntOrNull(it, 2);
  return tmp1_elvis_lhs == null ? o : tmp1_elvis_lhs;
}
var defaults$$inlined$formForType$24Class;
function defaults$$inlined$formForType$24() {
  if (defaults$$inlined$formForType$24Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.ae8_1 = $size;
        this.ve7_1 = $annotation;
        this.we7_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.xe7_1 = $serializer.az().l11();
        this.ye7_1 = $name;
        this.ze7_1 = $priority;
      }
      qdu() {
        return this.ve7_1;
      }
      f94() {
        return this.we7_1;
      }
      pdu() {
        return this.xe7_1;
      }
      k20() {
        return this.ye7_1;
      }
      cdu() {
        return this.ze7_1;
      }
      idu(module_0, selector) {
        return this.ae8_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_23);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$24Class = $;
  }
  return defaults$$inlined$formForType$24Class;
}
function defaults$o$form$lambda_24($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextInput())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.bbs(Align_End_getInstance());
  var tmp_0 = defaults$o$form$lambda$lambda_46;
  view.xah(view.gcn_1, mutable.bak(tmp_0, defaults$o$form$lambda$lambda_47));
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_46(it) {
  return toString_3(it, 2);
}
function defaults$o$form$lambda$lambda_47(o, it) {
  var tmp1_elvis_lhs = it == null ? null : toLongOrNull(it, 2);
  return tmp1_elvis_lhs == null ? o : tmp1_elvis_lhs;
}
var defaults$$inlined$formForType$25Class;
function defaults$$inlined$formForType$25() {
  if (defaults$$inlined$formForType$25Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.ge8_1 = $size;
        this.be8_1 = $annotation;
        this.ce8_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.de8_1 = $serializer.az().l11();
        this.ee8_1 = $name;
        this.fe8_1 = $priority;
      }
      qdu() {
        return this.be8_1;
      }
      f94() {
        return this.ce8_1;
      }
      pdu() {
        return this.de8_1;
      }
      k20() {
        return this.ee8_1;
      }
      cdu() {
        return this.fe8_1;
      }
      idu(module_0, selector) {
        return this.ge8_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_24);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$25Class = $;
  }
  return defaults$$inlined$formForType$25Class;
}
function defaults$o$form$lambda_25($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (NumberInput())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.bbs(Align_End_getInstance());
  var tmp_0 = defaults$o$form$lambda$lambda_48;
  view.xah(view.xc5_1, mutable.tak(tmp_0, defaults$o$form$lambda$lambda_49));
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_48(it) {
  return it == null ? null : it;
}
function defaults$o$form$lambda$lambda_49(it) {
  return it == null ? null : it;
}
var defaults$$inlined$formForType$26Class;
function defaults$$inlined$formForType$26() {
  if (defaults$$inlined$formForType$26Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.me8_1 = $size;
        this.he8_1 = $annotation;
        this.ie8_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.je8_1 = $serializer.az().l11();
        this.ke8_1 = $name;
        this.le8_1 = $priority;
      }
      qdu() {
        return this.he8_1;
      }
      f94() {
        return this.ie8_1;
      }
      pdu() {
        return this.je8_1;
      }
      k20() {
        return this.ke8_1;
      }
      cdu() {
        return this.le8_1;
      }
      idu(module_0, selector) {
        return this.me8_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_25);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$26Class = $;
  }
  return defaults$$inlined$formForType$26Class;
}
function defaults$o$form$lambda_26($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (NumberInput())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.bbs(Align_End_getInstance());
  view.xah(view.xc5_1, mutable);
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
var defaults$$inlined$formForType$27Class;
function defaults$$inlined$formForType$27() {
  if (defaults$$inlined$formForType$27Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.se8_1 = $size;
        this.ne8_1 = $annotation;
        this.oe8_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.pe8_1 = $serializer.az().l11();
        this.qe8_1 = $name;
        this.re8_1 = $priority;
      }
      qdu() {
        return this.ne8_1;
      }
      f94() {
        return this.oe8_1;
      }
      pdu() {
        return this.pe8_1;
      }
      k20() {
        return this.qe8_1;
      }
      cdu() {
        return this.re8_1;
      }
      idu(module_0, selector) {
        return this.se8_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_26);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$27Class = $;
  }
  return defaults$$inlined$formForType$27Class;
}
function defaults$o$form$lambda_27($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (NumberInput())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.bbs(Align_End_getInstance());
  var tmp_0 = defaults$o$form$lambda$lambda_50;
  view.xah(view.xc5_1, mutable.bak(tmp_0, defaults$o$form$lambda$lambda_51));
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_50(it) {
  return it;
}
function defaults$o$form$lambda$lambda_51(o, it) {
  var tmp1_elvis_lhs = it == null ? null : it;
  return tmp1_elvis_lhs == null ? o : tmp1_elvis_lhs;
}
var defaults$$inlined$formForType$28Class;
function defaults$$inlined$formForType$28() {
  if (defaults$$inlined$formForType$28Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.ye8_1 = $size;
        this.te8_1 = $annotation;
        this.ue8_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.ve8_1 = $serializer.az().l11();
        this.we8_1 = $name;
        this.xe8_1 = $priority;
      }
      qdu() {
        return this.te8_1;
      }
      f94() {
        return this.ue8_1;
      }
      pdu() {
        return this.ve8_1;
      }
      k20() {
        return this.we8_1;
      }
      cdu() {
        return this.xe8_1;
      }
      idu(module_0, selector) {
        return this.ye8_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_27);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$28Class = $;
  }
  return defaults$$inlined$formForType$28Class;
}
function defaults$o$form$lambda_28($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (NumberInput())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.bbs(Align_End_getInstance());
  view.xah(view.xc5_1, nullable(mutable));
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
var defaults$$inlined$formForType$29Class;
function defaults$$inlined$formForType$29() {
  if (defaults$$inlined$formForType$29Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.ee9_1 = $size;
        this.ze8_1 = $annotation;
        this.ae9_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.be9_1 = $serializer.az().l11();
        this.ce9_1 = $name;
        this.de9_1 = $priority;
      }
      qdu() {
        return this.ze8_1;
      }
      f94() {
        return this.ae9_1;
      }
      pdu() {
        return this.be9_1;
      }
      k20() {
        return this.ce9_1;
      }
      cdu() {
        return this.de9_1;
      }
      idu(module_0, selector) {
        return this.ee9_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_28);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$29Class = $;
  }
  return defaults$$inlined$formForType$29Class;
}
function defaults$o$form$lambda_29($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextInput())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  var tmp_0 = defaults$o$form$lambda$lambda_52;
  view.xah(view.gcn_1, mutable.bak(tmp_0, defaults$o$form$lambda$lambda_53));
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_52(it) {
  return toString_0(it.z2_1);
}
function defaults$o$form$lambda$lambda_53(o, it) {
  var tmp0_elvis_lhs = firstOrNull(it);
  var tmp;
  var tmp_0 = tmp0_elvis_lhs;
  if ((tmp_0 == null ? null : new (Char())(tmp_0)) == null) {
    tmp = o.z2_1;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return new (Char())(tmp);
}
var defaults$$inlined$formForType$30Class;
function defaults$$inlined$formForType$30() {
  if (defaults$$inlined$formForType$30Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.ke9_1 = $size;
        this.fe9_1 = $annotation;
        this.ge9_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.he9_1 = $serializer.az().l11();
        this.ie9_1 = $name;
        this.je9_1 = $priority;
      }
      qdu() {
        return this.fe9_1;
      }
      f94() {
        return this.ge9_1;
      }
      pdu() {
        return this.he9_1;
      }
      k20() {
        return this.ie9_1;
      }
      cdu() {
        return this.je9_1;
      }
      idu(module_0, selector) {
        return this.ke9_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_29);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$30Class = $;
  }
  return defaults$$inlined$formForType$30Class;
}
function defaults$o$form$lambda_30($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextInput())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  var tmp_0 = defaults$o$form$lambda$lambda_54;
  view.xah(view.gcn_1, mutable.bak(tmp_0, defaults$o$form$lambda$lambda_55));
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_54(it) {
  return toString(it);
}
function defaults$o$form$lambda$lambda_55(o, it) {
  var tmp = firstOrNull(it);
  return tmp == null ? null : new (Char())(tmp);
}
var defaults$$inlined$formForType$31Class;
function defaults$$inlined$formForType$31() {
  if (defaults$$inlined$formForType$31Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.qe9_1 = $size;
        this.le9_1 = $annotation;
        this.me9_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.ne9_1 = $serializer.az().l11();
        this.oe9_1 = $name;
        this.pe9_1 = $priority;
      }
      qdu() {
        return this.le9_1;
      }
      f94() {
        return this.me9_1;
      }
      pdu() {
        return this.ne9_1;
      }
      k20() {
        return this.oe9_1;
      }
      cdu() {
        return this.pe9_1;
      }
      idu(module_0, selector) {
        return this.qe9_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_30);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$31Class = $;
  }
  return defaults$$inlined$formForType$31Class;
}
function defaults$o$form$lambda_31($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextInput())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.xah(view.gcn_1, mutable);
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
var defaults$$inlined$formForType$32Class;
function defaults$$inlined$formForType$32() {
  if (defaults$$inlined$formForType$32Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority) {
        this.re9_1 = $annotation;
        this.se9_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.te9_1 = $serializer.az().l11();
        this.ue9_1 = $name;
        this.ve9_1 = $priority;
      }
      qdu() {
        return this.re9_1;
      }
      f94() {
        return this.se9_1;
      }
      pdu() {
        return this.te9_1;
      }
      k20() {
        return this.ue9_1;
      }
      cdu() {
        return this.ve9_1;
      }
      idu(module_0, selector) {
        // Inline function 'kotlin.collections.find' call
        var tmp0 = selector.fdu_1;
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (element.l4s_1 === 'com.lightningkite.lightningdb.MaxLength') {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        var tmp0_safe_receiver = tmp$ret$1;
        var maxLengthAnno = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m4s_1;
        var tmp = maxLengthAnno == null ? null : maxLengthAnno.p3('size');
        var tmp2_safe_receiver = tmp instanceof IntValue() ? tmp : null;
        var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.f4v_1;
        var tmp_0;
        if (tmp3_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.takeUnless' call
          var tmp_1;
          if (!(tmp3_safe_receiver === -1)) {
            tmp_1 = tmp3_safe_receiver;
          } else {
            tmp_1 = null;
          }
          tmp_0 = tmp_1;
        }
        var maxSize = tmp_0;
        var tmp_2 = maxLengthAnno == null ? null : maxLengthAnno.p3('average');
        var tmp5_safe_receiver = tmp_2 instanceof IntValue() ? tmp_2 : null;
        var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.f4v_1;
        var tmp_3;
        if (tmp6_safe_receiver == null) {
          tmp_3 = null;
        } else {
          // Inline function 'kotlin.takeUnless' call
          var tmp_4;
          if (!(tmp6_safe_receiver === -1)) {
            tmp_4 = tmp6_safe_receiver;
          } else {
            tmp_4 = null;
          }
          tmp_3 = tmp_4;
        }
        var tmp7_safe_receiver = tmp_3;
        var tmp8_elvis_lhs = tmp7_safe_receiver == null ? null : tmp7_safe_receiver;
        var tmp_5;
        if (tmp8_elvis_lhs == null) {
          tmp_5 = maxSize == null ? null : maxSize / 8.0;
        } else {
          tmp_5 = tmp8_elvis_lhs;
        }
        var tmp10_elvis_lhs = tmp_5;
        var averageSize = tmp10_elvis_lhs == null ? 20.0 : tmp10_elvis_lhs;
        return new (FormSize())(averageSize, 1.0);
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_31);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$32Class = $;
  }
  return defaults$$inlined$formForType$32Class;
}
function defaults$o$view$lambda_1($this$ViewRenderer, field, readable) {
  var it = readable;
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())($this$ViewRenderer.pc());
  var tmp0_elvis_lhs = $this$ViewRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$ViewRenderer : tmp0_elvis_lhs;
  $this$ViewRenderer.ebb(p, view);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl_1(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_1(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var tmp$ret$0 = $this$reactiveScope.baj(it);
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  $this$ViewRenderer.fbb(p, view);
  return view;
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var defaults$$inlined$viewForType$1Class;
function defaults$$inlined$viewForType$1() {
  if (defaults$$inlined$viewForType$1Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority) {
        this.we9_1 = $annotation;
        this.xe9_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.ye9_1 = $serializer.az().l11();
        this.ze9_1 = $name;
        this.aea_1 = $priority;
      }
      qdu() {
        return this.we9_1;
      }
      f94() {
        return this.xe9_1;
      }
      pdu() {
        return this.ye9_1;
      }
      k20() {
        return this.ze9_1;
      }
      cdu() {
        return this.aea_1;
      }
      idu(module_0, selector) {
        // Inline function 'kotlin.collections.find' call
        var tmp0 = selector.fdu_1;
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (element.l4s_1 === 'com.lightningkite.lightningdb.MaxLength') {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        var tmp0_safe_receiver = tmp$ret$1;
        var maxLengthAnno = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m4s_1;
        var tmp = maxLengthAnno == null ? null : maxLengthAnno.p3('size');
        var tmp2_safe_receiver = tmp instanceof IntValue() ? tmp : null;
        var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.f4v_1;
        var tmp_0;
        if (tmp3_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.takeUnless' call
          var tmp_1;
          if (!(tmp3_safe_receiver === -1)) {
            tmp_1 = tmp3_safe_receiver;
          } else {
            tmp_1 = null;
          }
          tmp_0 = tmp_1;
        }
        var maxSize = tmp_0;
        var tmp_2 = maxLengthAnno == null ? null : maxLengthAnno.p3('average');
        var tmp5_safe_receiver = tmp_2 instanceof IntValue() ? tmp_2 : null;
        var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.f4v_1;
        var tmp_3;
        if (tmp6_safe_receiver == null) {
          tmp_3 = null;
        } else {
          // Inline function 'kotlin.takeUnless' call
          var tmp_4;
          if (!(tmp6_safe_receiver === -1)) {
            tmp_4 = tmp6_safe_receiver;
          } else {
            tmp_4 = null;
          }
          tmp_3 = tmp_4;
        }
        var tmp7_safe_receiver = tmp_3;
        var tmp8_elvis_lhs = tmp7_safe_receiver == null ? null : tmp7_safe_receiver;
        var tmp_5;
        if (tmp8_elvis_lhs == null) {
          tmp_5 = maxSize == null ? null : maxSize / 8.0;
        } else {
          tmp_5 = tmp8_elvis_lhs;
        }
        var tmp10_elvis_lhs = tmp_5;
        var averageSize = tmp10_elvis_lhs == null ? 20.0 : tmp10_elvis_lhs;
        return new (FormSize())(averageSize, 1.0);
      }
      ndu(module_0, selector) {
        var tmp = Companion_instance_0;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.odu(module_0, this, tmp_0, VOID, VOID, defaults$o$view$lambda_1);
        return isInterface(tmp_1, ViewRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator_0()]);
    defaults$$inlined$viewForType$1Class = $;
  }
  return defaults$$inlined$viewForType$1Class;
}
function defaults$o$form$lambda_32($this$FormRenderer, field, mutable) {
  var tmp = sizeConstraints($this$FormRenderer, VOID, VOID, get_rem(10));
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp$ret$0 = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  var tmp_0 = $this$FormRenderer.ibb(tmp, tmp$ret$0);
  // Inline function 'com.lightningkite.kiteui.views.direct.textArea' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextArea())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.xah(view.qcl_1, mutable);
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp_0, view);
}
var defaults$$inlined$formForType$33Class;
function defaults$$inlined$formForType$33() {
  if (defaults$$inlined$formForType$33Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.gea_1 = $size;
        this.bea_1 = $annotation;
        this.cea_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.dea_1 = $serializer.az().l11();
        this.eea_1 = $name;
        this.fea_1 = $priority;
      }
      qdu() {
        return this.bea_1;
      }
      f94() {
        return this.cea_1;
      }
      pdu() {
        return this.dea_1;
      }
      k20() {
        return this.eea_1;
      }
      cdu() {
        return this.fea_1;
      }
      idu(module_0, selector) {
        return this.gea_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_32);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$33Class = $;
  }
  return defaults$$inlined$formForType$33Class;
}
function defaults$o$view$lambda_2($this$ViewRenderer, field, readable) {
  var it = readable;
  var tmp = sizeConstraints($this$ViewRenderer, VOID, VOID, VOID, get_rem(3));
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())($this$ViewRenderer.pc());
  var tmp0_elvis_lhs = $this$ViewRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$ViewRenderer : tmp0_elvis_lhs;
  $this$ViewRenderer.ebb(p, view);
  var tmp_0 = KMutableProperty0();
  var tmp_1 = TextView$_get_content_$ref_4pzcwl_2(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb_2(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var tmp$ret$0 = substringBefore($this$reactiveScope.baj(it), _Char___init__impl__6a9atx(10));
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  view.yco(false);
  view.xco(true);
  $this$ViewRenderer.fbb(p, view);
  return $this$ViewRenderer.jbb(tmp, view);
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var defaults$$inlined$viewForType$2Class;
function defaults$$inlined$viewForType$2() {
  if (defaults$$inlined$viewForType$2Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.mea_1 = $size;
        this.hea_1 = $annotation;
        this.iea_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.jea_1 = $serializer.az().l11();
        this.kea_1 = $name;
        this.lea_1 = $priority;
      }
      qdu() {
        return this.hea_1;
      }
      f94() {
        return this.iea_1;
      }
      pdu() {
        return this.jea_1;
      }
      k20() {
        return this.kea_1;
      }
      cdu() {
        return this.lea_1;
      }
      idu(module_0, selector) {
        return this.mea_1;
      }
      ndu(module_0, selector) {
        var tmp = Companion_instance_0;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.odu(module_0, this, tmp_0, VOID, VOID, defaults$o$view$lambda_2);
        return isInterface(tmp_1, ViewRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator_0()]);
    defaults$$inlined$viewForType$2Class = $;
  }
  return defaults$$inlined$viewForType$2Class;
}
function defaults$o$view$lambda_3($this$ViewRenderer, field, readable) {
  var it = readable;
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())($this$ViewRenderer.pc());
  var tmp0_elvis_lhs = $this$ViewRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$ViewRenderer : tmp0_elvis_lhs;
  $this$ViewRenderer.ebb(p, view);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl_3(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_3(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var tmp$ret$0 = substringBefore($this$reactiveScope.baj(it), _Char___init__impl__6a9atx(10));
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  view.yco(false);
  view.xco(true);
  $this$ViewRenderer.fbb(p, view);
  return view;
}
function TextView$_get_content_$ref_4pzcwl_3(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_3(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var defaults$$inlined$viewForType$3Class;
function defaults$$inlined$viewForType$3() {
  if (defaults$$inlined$viewForType$3Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.sea_1 = $size;
        this.nea_1 = $annotation;
        this.oea_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.pea_1 = $serializer.az().l11();
        this.qea_1 = $name;
        this.rea_1 = $priority;
      }
      qdu() {
        return this.nea_1;
      }
      f94() {
        return this.oea_1;
      }
      pdu() {
        return this.pea_1;
      }
      k20() {
        return this.qea_1;
      }
      cdu() {
        return this.rea_1;
      }
      idu(module_0, selector) {
        return this.sea_1;
      }
      ndu(module_0, selector) {
        var tmp = Companion_instance_0;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.odu(module_0, this, tmp_0, VOID, VOID, defaults$o$view$lambda_3);
        return isInterface(tmp_1, ViewRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator_0()]);
    defaults$$inlined$viewForType$3Class = $;
  }
  return defaults$$inlined$viewForType$3Class;
}
function defaults$o$form$lambda_33($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.xbm(true);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = view.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (TextInput())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  var tmp_0 = defaults$o$form$lambda$lambda_56;
  view_0.xah(view_0.gcn_1, mutable.tak(tmp_0, defaults$o$form$lambda$lambda_57));
  view.fbb(p_0, view_0);
  view.jbb(tmp, view_0);
  errorText(view);
  $this$FormRenderer.fbb(p, view);
  return view;
}
function defaults$o$form$lambda$lambda_56(it) {
  return _EmailAddress___get_raw__impl__6ose2(it.c3n_1);
}
function defaults$o$form$lambda$lambda_57(it) {
  return new (EmailAddress())(toEmailAddress(it));
}
var defaults$$inlined$formForType$34Class;
function defaults$$inlined$formForType$34() {
  if (defaults$$inlined$formForType$34Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.yea_1 = $size;
        this.tea_1 = $annotation;
        this.uea_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.vea_1 = $serializer.az().l11();
        this.wea_1 = $name;
        this.xea_1 = $priority;
      }
      qdu() {
        return this.tea_1;
      }
      f94() {
        return this.uea_1;
      }
      pdu() {
        return this.vea_1;
      }
      k20() {
        return this.wea_1;
      }
      cdu() {
        return this.xea_1;
      }
      idu(module_0, selector) {
        return this.yea_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_33);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$34Class = $;
  }
  return defaults$$inlined$formForType$34Class;
}
function defaults$o$view$lambda_4($this$ViewRenderer, field, readable) {
  var it = readable;
  // Inline function 'com.lightningkite.kiteui.views.direct.externalLink' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (ExternalLink())($this$ViewRenderer.pc());
  var tmp0_elvis_lhs = $this$ViewRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$ViewRenderer : tmp0_elvis_lhs;
  $this$ViewRenderer.ebb(p, view);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl_4(view_0);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_4(view_0));
  reactiveScope(view_0, ($this$reactiveScope) => {
    var tmp$ret$0 = _EmailAddress___get_raw__impl__6ose2($this$reactiveScope.baj(it).c3n_1);
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  view_0.yco(false);
  view_0.xco(true);
  view.fbb(p_0, view_0);
  var tmp_1 = KMutableProperty0();
  var tmp_2 = ExternalLink$_get_to_$ref_jqs3qa(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('to', 0, tmp_1, tmp_2, ExternalLink$_set_to_$ref_l7iod2(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var tmp$ret$5 = _EmailAddress___get_url__impl__h7wdun($this$reactiveScope.baj(it).c3n_1);
    this_1.set(tmp$ret$5);
    return Unit_instance;
  });
  $this$ViewRenderer.fbb(p, view);
  return view;
}
function TextView$_get_content_$ref_4pzcwl_4(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_4(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function ExternalLink$_get_to_$ref_jqs3qa(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.ExternalLink.to' call
    // Inline function 'com.lightningkite.kiteui.views.href' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.href;
    return (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
  };
}
function ExternalLink$_set_to_$ref_l7iod2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.ExternalLink.to' call
    // Inline function 'com.lightningkite.kiteui.views.href' call
    p0.tb5_1.zb3_1.ib7_1.href = _this__u8e3s4;
    return Unit_instance;
  };
}
var defaults$$inlined$viewForType$4Class;
function defaults$$inlined$viewForType$4() {
  if (defaults$$inlined$viewForType$4Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.eeb_1 = $size;
        this.zea_1 = $annotation;
        this.aeb_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.beb_1 = $serializer.az().l11();
        this.ceb_1 = $name;
        this.deb_1 = $priority;
      }
      qdu() {
        return this.zea_1;
      }
      f94() {
        return this.aeb_1;
      }
      pdu() {
        return this.beb_1;
      }
      k20() {
        return this.ceb_1;
      }
      cdu() {
        return this.deb_1;
      }
      idu(module_0, selector) {
        return this.eeb_1;
      }
      ndu(module_0, selector) {
        var tmp = Companion_instance_0;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.odu(module_0, this, tmp_0, VOID, VOID, defaults$o$view$lambda_4);
        return isInterface(tmp_1, ViewRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator_0()]);
    defaults$$inlined$viewForType$4Class = $;
  }
  return defaults$$inlined$viewForType$4Class;
}
function defaults$o$form$lambda_34($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.xbm(true);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = view.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (TextInput())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  var tmp_0 = defaults$o$form$lambda$lambda_58;
  view_0.xah(view_0.gcn_1, mutable.tak(tmp_0, defaults$o$form$lambda$lambda_59));
  view.fbb(p_0, view_0);
  view.jbb(tmp, view_0);
  errorText(view);
  $this$FormRenderer.fbb(p, view);
  return view;
}
function defaults$o$form$lambda$lambda_58(it) {
  return _PhoneNumber___get_raw__impl__gc2pmp(it.h3n_1);
}
function defaults$o$form$lambda$lambda_59(it) {
  return new (PhoneNumber())(toPhoneNumber(it));
}
var defaults$$inlined$formForType$35Class;
function defaults$$inlined$formForType$35() {
  if (defaults$$inlined$formForType$35Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.keb_1 = $size;
        this.feb_1 = $annotation;
        this.geb_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.heb_1 = $serializer.az().l11();
        this.ieb_1 = $name;
        this.jeb_1 = $priority;
      }
      qdu() {
        return this.feb_1;
      }
      f94() {
        return this.geb_1;
      }
      pdu() {
        return this.heb_1;
      }
      k20() {
        return this.ieb_1;
      }
      cdu() {
        return this.jeb_1;
      }
      idu(module_0, selector) {
        return this.keb_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_34);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$35Class = $;
  }
  return defaults$$inlined$formForType$35Class;
}
function defaults$o$view$lambda_5($this$ViewRenderer, field, readable) {
  var it = readable;
  // Inline function 'com.lightningkite.kiteui.views.direct.externalLink' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (ExternalLink())($this$ViewRenderer.pc());
  var tmp0_elvis_lhs = $this$ViewRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$ViewRenderer : tmp0_elvis_lhs;
  $this$ViewRenderer.ebb(p, view);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl_5(view_0);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_5(view_0));
  reactiveScope(view_0, ($this$reactiveScope) => {
    var tmp$ret$0 = _PhoneNumber___get_raw__impl__gc2pmp($this$reactiveScope.baj(it).h3n_1);
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  view_0.yco(false);
  view_0.xco(true);
  view.fbb(p_0, view_0);
  var tmp_1 = KMutableProperty0();
  var tmp_2 = ExternalLink$_get_to_$ref_jqs3qa_0(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('to', 0, tmp_1, tmp_2, ExternalLink$_set_to_$ref_l7iod2_0(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var tmp$ret$5 = _PhoneNumber___get_url__impl__12igm0($this$reactiveScope.baj(it).h3n_1);
    this_1.set(tmp$ret$5);
    return Unit_instance;
  });
  $this$ViewRenderer.fbb(p, view);
  return view;
}
function TextView$_get_content_$ref_4pzcwl_5(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_5(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function ExternalLink$_get_to_$ref_jqs3qa_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.ExternalLink.to' call
    // Inline function 'com.lightningkite.kiteui.views.href' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.href;
    return (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
  };
}
function ExternalLink$_set_to_$ref_l7iod2_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.ExternalLink.to' call
    // Inline function 'com.lightningkite.kiteui.views.href' call
    p0.tb5_1.zb3_1.ib7_1.href = _this__u8e3s4;
    return Unit_instance;
  };
}
var defaults$$inlined$viewForType$5Class;
function defaults$$inlined$viewForType$5() {
  if (defaults$$inlined$viewForType$5Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.qeb_1 = $size;
        this.leb_1 = $annotation;
        this.meb_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.neb_1 = $serializer.az().l11();
        this.oeb_1 = $name;
        this.peb_1 = $priority;
      }
      qdu() {
        return this.leb_1;
      }
      f94() {
        return this.meb_1;
      }
      pdu() {
        return this.neb_1;
      }
      k20() {
        return this.oeb_1;
      }
      cdu() {
        return this.peb_1;
      }
      idu(module_0, selector) {
        return this.qeb_1;
      }
      ndu(module_0, selector) {
        var tmp = Companion_instance_0;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.odu(module_0, this, tmp_0, VOID, VOID, defaults$o$view$lambda_5);
        return isInterface(tmp_1, ViewRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator_0()]);
    defaults$$inlined$viewForType$5Class = $;
  }
  return defaults$$inlined$viewForType$5Class;
}
function defaults$o$form$lambda_35($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.select' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Select())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  // Inline function 'kotlin.collections.map' call
  var this_0 = Companion_getInstance_0().r27();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$1 = Companion_getInstance_0().d26(item);
    destination.v(tmp$ret$1);
  }
  var tmp_0 = _Constant___init__impl__v45mub(destination);
  view.mcf(mutable, new (Constant())(tmp_0), defaults$o$form$lambda$lambda_60);
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_60(it) {
  return it.g26();
}
var defaults$$inlined$formForType$36Class;
function defaults$$inlined$formForType$36() {
  if (defaults$$inlined$formForType$36Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.web_1 = $size;
        this.reb_1 = $annotation;
        this.seb_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.teb_1 = $serializer.az().l11();
        this.ueb_1 = $name;
        this.veb_1 = $priority;
      }
      qdu() {
        return this.reb_1;
      }
      f94() {
        return this.seb_1;
      }
      pdu() {
        return this.teb_1;
      }
      k20() {
        return this.ueb_1;
      }
      cdu() {
        return this.veb_1;
      }
      idu(module_0, selector) {
        return this.web_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_35);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$36Class = $;
  }
  return defaults$$inlined$formForType$36Class;
}
function defaults$o$form$lambda_36($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.select' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Select())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  var tmp_0 = listOf_0(null);
  // Inline function 'kotlin.collections.map' call
  var this_0 = Companion_getInstance_0().r27();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$1 = Companion_getInstance_0().d26(item);
    destination.v(tmp$ret$1);
  }
  var tmp_1 = _Constant___init__impl__v45mub(plus(tmp_0, destination));
  view.mcf(mutable, new (Constant())(tmp_1), defaults$o$form$lambda$lambda_61);
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_61(it) {
  var tmp1_elvis_lhs = it == null ? null : it.g26();
  return tmp1_elvis_lhs == null ? 'N/A' : tmp1_elvis_lhs;
}
var defaults$$inlined$formForType$37Class;
function defaults$$inlined$formForType$37() {
  if (defaults$$inlined$formForType$37Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.cec_1 = $size;
        this.xeb_1 = $annotation;
        this.yeb_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.zeb_1 = $serializer.az().l11();
        this.aec_1 = $name;
        this.bec_1 = $priority;
      }
      qdu() {
        return this.xeb_1;
      }
      f94() {
        return this.yeb_1;
      }
      pdu() {
        return this.zeb_1;
      }
      k20() {
        return this.aec_1;
      }
      cdu() {
        return this.bec_1;
      }
      idu(module_0, selector) {
        return this.cec_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_36);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$37Class = $;
  }
  return defaults$$inlined$formForType$37Class;
}
function defaults$o$view$lambda_6($this$ViewRenderer, field, readable) {
  var it = readable;
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())($this$ViewRenderer.pc());
  var tmp0_elvis_lhs = $this$ViewRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$ViewRenderer : tmp0_elvis_lhs;
  $this$ViewRenderer.ebb(p, view);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl_6(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_6(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var tmp$ret$0 = '' + $this$reactiveScope.baj(it).w3l_1 + ', ' + $this$reactiveScope.baj(it).x3l_1;
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  $this$ViewRenderer.fbb(p, view);
  return view;
}
function TextView$_get_content_$ref_4pzcwl_6(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_6(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var defaults$$inlined$viewForType$6Class;
function defaults$$inlined$viewForType$6() {
  if (defaults$$inlined$viewForType$6Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.iec_1 = $size;
        this.dec_1 = $annotation;
        this.eec_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.fec_1 = $serializer.az().l11();
        this.gec_1 = $name;
        this.hec_1 = $priority;
      }
      qdu() {
        return this.dec_1;
      }
      f94() {
        return this.eec_1;
      }
      pdu() {
        return this.fec_1;
      }
      k20() {
        return this.gec_1;
      }
      cdu() {
        return this.hec_1;
      }
      idu(module_0, selector) {
        return this.iec_1;
      }
      ndu(module_0, selector) {
        var tmp = Companion_instance_0;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.odu(module_0, this, tmp_0, VOID, VOID, defaults$o$view$lambda_6);
        return isInterface(tmp_1, ViewRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator_0()]);
    defaults$$inlined$viewForType$6Class = $;
  }
  return defaults$$inlined$viewForType$6Class;
}
function defaults$o$form$lambda_37($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.xbm(false);
  var tmp = get_expanding(view);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp$ret$0 = view.hbb(FieldSemantic_getInstance());
  var tmp_0 = view.ibb(tmp, tmp$ret$0);
  // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (NumberInput())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.NumberInput.hint' call
  var value = 'Latitude';
  // Inline function 'com.lightningkite.kiteui.views.placeholder' call
  view_0.tb5_1.zb3_1.ib7_1.placeholder = value;
  var tmp_1 = defaults$o$form$lambda$lambda_62;
  view_0.xah(view_0.xc5_1, mutable.bak(tmp_1, defaults$o$form$lambda$lambda_63));
  view.fbb(p_0, view_0);
  view.jbb(tmp_0, view_0);
  var tmp_2 = get_expanding(view);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp$ret$6 = view.hbb(FieldSemantic_getInstance());
  var tmp_3 = view.ibb(tmp_2, tmp$ret$6);
  // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (NumberInput())(view.pc());
  var tmp0_elvis_lhs_1 = view.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.ebb(p_1, view_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.NumberInput.hint' call
  var value_0 = 'Longitude';
  // Inline function 'com.lightningkite.kiteui.views.placeholder' call
  view_1.tb5_1.zb3_1.ib7_1.placeholder = value_0;
  var tmp_4 = defaults$o$form$lambda$lambda_64;
  view_1.xah(view_1.xc5_1, mutable.bak(tmp_4, defaults$o$form$lambda$lambda_65));
  view.fbb(p_1, view_1);
  view.jbb(tmp_3, view_1);
  $this$FormRenderer.fbb(p, view);
  return view;
}
function defaults$o$form$lambda$lambda_62(it) {
  return it.w3l_1;
}
function defaults$o$form$lambda$lambda_63(o, it) {
  return o.c3m(it == null ? 0.0 : it);
}
function defaults$o$form$lambda$lambda_64(it) {
  return it.x3l_1;
}
function defaults$o$form$lambda$lambda_65(o, it) {
  return o.c3m(VOID, it == null ? 0.0 : it);
}
var defaults$$inlined$formForType$38Class;
function defaults$$inlined$formForType$38() {
  if (defaults$$inlined$formForType$38Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.oec_1 = $size;
        this.jec_1 = $annotation;
        this.kec_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.lec_1 = $serializer.az().l11();
        this.mec_1 = $name;
        this.nec_1 = $priority;
      }
      qdu() {
        return this.jec_1;
      }
      f94() {
        return this.kec_1;
      }
      pdu() {
        return this.lec_1;
      }
      k20() {
        return this.mec_1;
      }
      cdu() {
        return this.nec_1;
      }
      idu(module_0, selector) {
        return this.oec_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_37);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$38Class = $;
  }
  return defaults$$inlined$formForType$38Class;
}
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = $this.pec_1.gah(Companion_getInstance_1().m2p(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function defaults$o$form$lambda_38($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.xbm(false);
  var tmp_0 = get_expanding(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (TextInput())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  var tmp_1 = defaults$o$form$lambda$lambda_66;
  view_0.xah(view_0.gcn_1, mutable.bak(tmp_1, defaults$o$form$lambda$lambda_67));
  view.fbb(p_0, view_0);
  view.jbb(tmp_0, view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Button())(view.pc());
  var tmp0_elvis_lhs_1 = view.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.ebb(p_1, view_1);
  icon(view_1, Companion_getInstance_2().icg_1, 'Regenerate');
  onClick(view_1, VOID, VOID, defaults$o$form$lambda$slambda_0(mutable));
  view.fbb(p_1, view_1);
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_66(it) {
  return it.toString();
}
function defaults$o$form$lambda$lambda_67(o, it) {
  var tmp;
  try {
    tmp = Companion_getInstance_1().xw(it);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Exception()) {
      var e = $p;
      tmp_0 = o;
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  return tmp;
}
var defaults$o$form$lambda$slambdaClass;
function defaults$o$form$lambda$slambda() {
  if (defaults$o$form$lambda$slambdaClass === VOID) {
    class $ {
      constructor($it) {
        this.pec_1 = $it;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    defaults$o$form$lambda$slambdaClass = $;
  }
  return defaults$o$form$lambda$slambdaClass;
}
function defaults$o$form$lambda$slambda_0($it) {
  var i = new (defaults$o$form$lambda$slambda())($it);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var defaults$$inlined$formForType$39Class;
function defaults$$inlined$formForType$39() {
  if (defaults$$inlined$formForType$39Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.vec_1 = $size;
        this.qec_1 = $annotation;
        this.rec_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.sec_1 = $serializer.az().l11();
        this.tec_1 = $name;
        this.uec_1 = $priority;
      }
      qdu() {
        return this.qec_1;
      }
      f94() {
        return this.rec_1;
      }
      pdu() {
        return this.sec_1;
      }
      k20() {
        return this.tec_1;
      }
      cdu() {
        return this.uec_1;
      }
      idu(module_0, selector) {
        return this.vec_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_38);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$39Class = $;
  }
  return defaults$$inlined$formForType$39Class;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp = $this.wec_1.gah(Companion_getInstance_1().m2p(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function defaults$o$form$lambda_39($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.xbm(false);
  var tmp_0 = get_expanding(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (TextInput())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  var tmp_1 = defaults$o$form$lambda$lambda_68;
  view_0.xah(view_0.gcn_1, mutable.bak(tmp_1, defaults$o$form$lambda$lambda_69));
  view.fbb(p_0, view_0);
  view.jbb(tmp_0, view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Button())(view.pc());
  var tmp0_elvis_lhs_1 = view.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.ebb(p_1, view_1);
  icon(view_1, Companion_getInstance_2().icg_1, 'Regenerate');
  onClick(view_1, VOID, VOID, defaults$o$form$lambda$slambda_2(mutable));
  view.fbb(p_1, view_1);
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_68(it) {
  return it.toString();
}
function defaults$o$form$lambda$lambda_69(o, it) {
  var tmp;
  try {
    tmp = Companion_getInstance_1().xw(it);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Exception()) {
      var e = $p;
      tmp_0 = o;
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  return tmp;
}
var defaults$o$form$lambda$slambdaClass_0;
function defaults$o$form$lambda$slambda_1() {
  if (defaults$o$form$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($it) {
        this.wec_1 = $it;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    defaults$o$form$lambda$slambdaClass_0 = $;
  }
  return defaults$o$form$lambda$slambdaClass_0;
}
function defaults$o$form$lambda$slambda_2($it) {
  var i = new (defaults$o$form$lambda$slambda_1())($it);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var defaults$$inlined$formForType$40Class;
function defaults$$inlined$formForType$40() {
  if (defaults$$inlined$formForType$40Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.ced_1 = $size;
        this.xec_1 = $annotation;
        this.yec_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.zec_1 = $serializer.az().l11();
        this.aed_1 = $name;
        this.bed_1 = $priority;
      }
      qdu() {
        return this.xec_1;
      }
      f94() {
        return this.yec_1;
      }
      pdu() {
        return this.zec_1;
      }
      k20() {
        return this.aed_1;
      }
      cdu() {
        return this.bed_1;
      }
      idu(module_0, selector) {
        return this.ced_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_39);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$40Class = $;
  }
  return defaults$$inlined$formForType$40Class;
}
function defaults$o$view$lambda_7($this$ViewRenderer, field, readable) {
  var it = readable;
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())($this$ViewRenderer.pc());
  var tmp0_elvis_lhs = $this$ViewRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$ViewRenderer : tmp0_elvis_lhs;
  $this$ViewRenderer.ebb(p, view);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl_7(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_7(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var tmp$ret$0 = $this$reactiveScope.baj(it).toString();
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  $this$ViewRenderer.fbb(p, view);
  return view;
}
function TextView$_get_content_$ref_4pzcwl_7(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_7(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var defaults$$inlined$viewForType$7Class;
function defaults$$inlined$viewForType$7() {
  if (defaults$$inlined$viewForType$7Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.ied_1 = $size;
        this.ded_1 = $annotation;
        this.eed_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.fed_1 = $serializer.az().l11();
        this.ged_1 = $name;
        this.hed_1 = $priority;
      }
      qdu() {
        return this.ded_1;
      }
      f94() {
        return this.eed_1;
      }
      pdu() {
        return this.fed_1;
      }
      k20() {
        return this.ged_1;
      }
      cdu() {
        return this.hed_1;
      }
      idu(module_0, selector) {
        return this.ied_1;
      }
      ndu(module_0, selector) {
        var tmp = Companion_instance_0;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.odu(module_0, this, tmp_0, VOID, VOID, defaults$o$view$lambda_7);
        return isInterface(tmp_1, ViewRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator_0()]);
    defaults$$inlined$viewForType$7Class = $;
  }
  return defaults$$inlined$viewForType$7Class;
}
function defaults$o$view$lambda_8($this$ViewRenderer, field, readable) {
  var it = readable;
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())($this$ViewRenderer.pc());
  var tmp0_elvis_lhs = $this$ViewRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$ViewRenderer : tmp0_elvis_lhs;
  $this$ViewRenderer.ebb(p, view);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl_8(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_8(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var tmp$ret$0 = $this$reactiveScope.baj(it).toString();
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  $this$ViewRenderer.fbb(p, view);
  return view;
}
function TextView$_get_content_$ref_4pzcwl_8(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_8(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var defaults$$inlined$viewForType$8Class;
function defaults$$inlined$viewForType$8() {
  if (defaults$$inlined$viewForType$8Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.oed_1 = $size;
        this.jed_1 = $annotation;
        this.ked_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.led_1 = $serializer.az().l11();
        this.med_1 = $name;
        this.ned_1 = $priority;
      }
      qdu() {
        return this.jed_1;
      }
      f94() {
        return this.ked_1;
      }
      pdu() {
        return this.led_1;
      }
      k20() {
        return this.med_1;
      }
      cdu() {
        return this.ned_1;
      }
      idu(module_0, selector) {
        return this.oed_1;
      }
      ndu(module_0, selector) {
        var tmp = Companion_instance_0;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.odu(module_0, this, tmp_0, VOID, VOID, defaults$o$view$lambda_8);
        return isInterface(tmp_1, ViewRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator_0()]);
    defaults$$inlined$viewForType$8Class = $;
  }
  return defaults$$inlined$viewForType$8Class;
}
function defaults$o$form$lambda_40($this$FormRenderer, field, mutable) {
  return text($this$FormRenderer, 'TODO');
}
var defaults$$inlined$formForType$41Class;
function defaults$$inlined$formForType$41() {
  if (defaults$$inlined$formForType$41Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.ued_1 = $size;
        this.ped_1 = $annotation;
        this.qed_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.red_1 = $serializer.az().l11();
        this.sed_1 = $name;
        this.ted_1 = $priority;
      }
      qdu() {
        return this.ped_1;
      }
      f94() {
        return this.qed_1;
      }
      pdu() {
        return this.red_1;
      }
      k20() {
        return this.sed_1;
      }
      cdu() {
        return this.ted_1;
      }
      idu(module_0, selector) {
        return this.ued_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_40);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$41Class = $;
  }
  return defaults$$inlined$formForType$41Class;
}
function defaults$o$form$lambda_41($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.localDateTimeField' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (LocalDateTimeField())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  var tmp_0 = defaults$o$form$lambda$lambda_70;
  view.xah(view.gc0_1, mutable.bak(tmp_0, defaults$o$form$lambda$lambda_71));
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_70(it) {
  return toLocalDateTime(it, Companion_getInstance_0().q27());
}
function defaults$o$form$lambda$lambda_71(old, it) {
  var tmp1_elvis_lhs = it == null ? null : toInstant(it, Companion_getInstance_0().q27());
  return tmp1_elvis_lhs == null ? old : tmp1_elvis_lhs;
}
var defaults$$inlined$formForType$42Class;
function defaults$$inlined$formForType$42() {
  if (defaults$$inlined$formForType$42Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.aee_1 = $size;
        this.ved_1 = $annotation;
        this.wed_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.xed_1 = $serializer.az().l11();
        this.yed_1 = $name;
        this.zed_1 = $priority;
      }
      qdu() {
        return this.ved_1;
      }
      f94() {
        return this.wed_1;
      }
      pdu() {
        return this.xed_1;
      }
      k20() {
        return this.yed_1;
      }
      cdu() {
        return this.zed_1;
      }
      idu(module_0, selector) {
        return this.aee_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_41);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$42Class = $;
  }
  return defaults$$inlined$formForType$42Class;
}
function defaults$o$form$lambda_42($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.localDateTimeField' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (LocalDateTimeField())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  var tmp_0 = defaults$o$form$lambda$lambda_72;
  view.xah(view.gc0_1, mutable.bak(tmp_0, defaults$o$form$lambda$lambda_73));
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_72(it) {
  return it == null ? null : toLocalDateTime(it, Companion_getInstance_0().q27());
}
function defaults$o$form$lambda$lambda_73(old, it) {
  return it == null ? null : toInstant(it, Companion_getInstance_0().q27());
}
var defaults$$inlined$formForType$43Class;
function defaults$$inlined$formForType$43() {
  if (defaults$$inlined$formForType$43Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.gee_1 = $size;
        this.bee_1 = $annotation;
        this.cee_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.dee_1 = $serializer.az().l11();
        this.eee_1 = $name;
        this.fee_1 = $priority;
      }
      qdu() {
        return this.bee_1;
      }
      f94() {
        return this.cee_1;
      }
      pdu() {
        return this.dee_1;
      }
      k20() {
        return this.eee_1;
      }
      cdu() {
        return this.fee_1;
      }
      idu(module_0, selector) {
        return this.gee_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_42);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$43Class = $;
  }
  return defaults$$inlined$formForType$43Class;
}
function defaults$o$form$lambda_43($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.localDateTimeField' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (LocalDateTimeField())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  var tmp_0 = defaults$o$form$lambda$lambda_74;
  view.xah(view.gc0_1, mutable.bak(tmp_0, defaults$o$form$lambda$lambda_75));
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_74(it) {
  return it;
}
function defaults$o$form$lambda$lambda_75(old, it) {
  return it == null ? old : it;
}
var defaults$$inlined$formForType$44Class;
function defaults$$inlined$formForType$44() {
  if (defaults$$inlined$formForType$44Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.mee_1 = $size;
        this.hee_1 = $annotation;
        this.iee_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.jee_1 = $serializer.az().l11();
        this.kee_1 = $name;
        this.lee_1 = $priority;
      }
      qdu() {
        return this.hee_1;
      }
      f94() {
        return this.iee_1;
      }
      pdu() {
        return this.jee_1;
      }
      k20() {
        return this.kee_1;
      }
      cdu() {
        return this.lee_1;
      }
      idu(module_0, selector) {
        return this.mee_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_43);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$44Class = $;
  }
  return defaults$$inlined$formForType$44Class;
}
function defaults$o$form$lambda_44($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.localDateTimeField' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (LocalDateTimeField())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.xah(view.gc0_1, mutable);
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
var defaults$$inlined$formForType$45Class;
function defaults$$inlined$formForType$45() {
  if (defaults$$inlined$formForType$45Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.see_1 = $size;
        this.nee_1 = $annotation;
        this.oee_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.pee_1 = $serializer.az().l11();
        this.qee_1 = $name;
        this.ree_1 = $priority;
      }
      qdu() {
        return this.nee_1;
      }
      f94() {
        return this.oee_1;
      }
      pdu() {
        return this.pee_1;
      }
      k20() {
        return this.qee_1;
      }
      cdu() {
        return this.ree_1;
      }
      idu(module_0, selector) {
        return this.see_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_44);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$45Class = $;
  }
  return defaults$$inlined$formForType$45Class;
}
function defaults$o$form$lambda_45($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.localDateField' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (LocalDateField())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  var tmp_0 = defaults$o$form$lambda$lambda_76;
  view.xah(view.lby_1, mutable.bak(tmp_0, defaults$o$form$lambda$lambda_77));
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_76(it) {
  return it;
}
function defaults$o$form$lambda$lambda_77(old, it) {
  return it == null ? old : it;
}
var defaults$$inlined$formForType$46Class;
function defaults$$inlined$formForType$46() {
  if (defaults$$inlined$formForType$46Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.yee_1 = $size;
        this.tee_1 = $annotation;
        this.uee_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.vee_1 = $serializer.az().l11();
        this.wee_1 = $name;
        this.xee_1 = $priority;
      }
      qdu() {
        return this.tee_1;
      }
      f94() {
        return this.uee_1;
      }
      pdu() {
        return this.vee_1;
      }
      k20() {
        return this.wee_1;
      }
      cdu() {
        return this.xee_1;
      }
      idu(module_0, selector) {
        return this.yee_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_45);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$46Class = $;
  }
  return defaults$$inlined$formForType$46Class;
}
function defaults$o$form$lambda_46($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.localDateField' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (LocalDateField())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.xah(view.lby_1, mutable);
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
var defaults$$inlined$formForType$47Class;
function defaults$$inlined$formForType$47() {
  if (defaults$$inlined$formForType$47Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.eef_1 = $size;
        this.zee_1 = $annotation;
        this.aef_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.bef_1 = $serializer.az().l11();
        this.cef_1 = $name;
        this.def_1 = $priority;
      }
      qdu() {
        return this.zee_1;
      }
      f94() {
        return this.aef_1;
      }
      pdu() {
        return this.bef_1;
      }
      k20() {
        return this.cef_1;
      }
      cdu() {
        return this.def_1;
      }
      idu(module_0, selector) {
        return this.eef_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_46);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$47Class = $;
  }
  return defaults$$inlined$formForType$47Class;
}
function defaults$o$form$lambda_47($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.localTimeField' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (LocalTimeField())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  var tmp_0 = defaults$o$form$lambda$lambda_78;
  view.xah(view.bc2_1, mutable.bak(tmp_0, defaults$o$form$lambda$lambda_79));
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
function defaults$o$form$lambda$lambda_78(it) {
  return it;
}
function defaults$o$form$lambda$lambda_79(old, it) {
  return it == null ? old : it;
}
var defaults$$inlined$formForType$48Class;
function defaults$$inlined$formForType$48() {
  if (defaults$$inlined$formForType$48Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.kef_1 = $size;
        this.fef_1 = $annotation;
        this.gef_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.hef_1 = $serializer.az().l11();
        this.ief_1 = $name;
        this.jef_1 = $priority;
      }
      qdu() {
        return this.fef_1;
      }
      f94() {
        return this.gef_1;
      }
      pdu() {
        return this.hef_1;
      }
      k20() {
        return this.ief_1;
      }
      cdu() {
        return this.jef_1;
      }
      idu(module_0, selector) {
        return this.kef_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_47);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$48Class = $;
  }
  return defaults$$inlined$formForType$48Class;
}
function defaults$o$form$lambda_48($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.localTimeField' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (LocalTimeField())($this$FormRenderer.pc());
  var tmp0_elvis_lhs = $this$FormRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
  $this$FormRenderer.ebb(p, view);
  view.xah(view.bc2_1, mutable);
  $this$FormRenderer.fbb(p, view);
  return $this$FormRenderer.jbb(tmp, view);
}
var defaults$$inlined$formForType$49Class;
function defaults$$inlined$formForType$49() {
  if (defaults$$inlined$formForType$49Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.qef_1 = $size;
        this.lef_1 = $annotation;
        this.mef_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.nef_1 = $serializer.az().l11();
        this.oef_1 = $name;
        this.pef_1 = $priority;
      }
      qdu() {
        return this.lef_1;
      }
      f94() {
        return this.mef_1;
      }
      pdu() {
        return this.nef_1;
      }
      k20() {
        return this.oef_1;
      }
      cdu() {
        return this.pef_1;
      }
      idu(module_0, selector) {
        return this.qef_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_48);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$49Class = $;
  }
  return defaults$$inlined$formForType$49Class;
}
function defaults$o$view$lambda_9($this$ViewRenderer, field, readable) {
  var prop = readable;
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())($this$ViewRenderer.pc());
  var tmp0_elvis_lhs = $this$ViewRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$ViewRenderer : tmp0_elvis_lhs;
  $this$ViewRenderer.ebb(p, view);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl_9(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_9(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var tmp$ret$0 = renderToString($this$reactiveScope.baj(prop));
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  $this$ViewRenderer.fbb(p, view);
  return view;
}
function TextView$_get_content_$ref_4pzcwl_9(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_9(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var defaults$$inlined$viewForType$9Class;
function defaults$$inlined$viewForType$9() {
  if (defaults$$inlined$viewForType$9Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.wef_1 = $size;
        this.ref_1 = $annotation;
        this.sef_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.tef_1 = $serializer.az().l11();
        this.uef_1 = $name;
        this.vef_1 = $priority;
      }
      qdu() {
        return this.ref_1;
      }
      f94() {
        return this.sef_1;
      }
      pdu() {
        return this.tef_1;
      }
      k20() {
        return this.uef_1;
      }
      cdu() {
        return this.vef_1;
      }
      idu(module_0, selector) {
        return this.wef_1;
      }
      ndu(module_0, selector) {
        var tmp = Companion_instance_0;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.odu(module_0, this, tmp_0, VOID, VOID, defaults$o$view$lambda_9);
        return isInterface(tmp_1, ViewRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator_0()]);
    defaults$$inlined$viewForType$9Class = $;
  }
  return defaults$$inlined$viewForType$9Class;
}
function defaults$o$view$lambda_10($this$ViewRenderer, field, readable) {
  var prop = readable;
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())($this$ViewRenderer.pc());
  var tmp0_elvis_lhs = $this$ViewRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$ViewRenderer : tmp0_elvis_lhs;
  $this$ViewRenderer.ebb(p, view);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl_10(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_10(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var tmp$ret$0 = renderToString_0($this$reactiveScope.baj(prop));
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  $this$ViewRenderer.fbb(p, view);
  return view;
}
function TextView$_get_content_$ref_4pzcwl_10(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_10(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var defaults$$inlined$viewForType$10Class;
function defaults$$inlined$viewForType$10() {
  if (defaults$$inlined$viewForType$10Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.ceg_1 = $size;
        this.xef_1 = $annotation;
        this.yef_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.zef_1 = $serializer.az().l11();
        this.aeg_1 = $name;
        this.beg_1 = $priority;
      }
      qdu() {
        return this.xef_1;
      }
      f94() {
        return this.yef_1;
      }
      pdu() {
        return this.zef_1;
      }
      k20() {
        return this.aeg_1;
      }
      cdu() {
        return this.beg_1;
      }
      idu(module_0, selector) {
        return this.ceg_1;
      }
      ndu(module_0, selector) {
        var tmp = Companion_instance_0;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.odu(module_0, this, tmp_0, VOID, VOID, defaults$o$view$lambda_10);
        return isInterface(tmp_1, ViewRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator_0()]);
    defaults$$inlined$viewForType$10Class = $;
  }
  return defaults$$inlined$viewForType$10Class;
}
function defaults$o$view$lambda_11($this$ViewRenderer, field, readable) {
  var prop = readable;
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())($this$ViewRenderer.pc());
  var tmp0_elvis_lhs = $this$ViewRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$ViewRenderer : tmp0_elvis_lhs;
  $this$ViewRenderer.ebb(p, view);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl_11(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_11(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var tmp$ret$0 = renderToString_1($this$reactiveScope.baj(prop));
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  $this$ViewRenderer.fbb(p, view);
  return view;
}
function TextView$_get_content_$ref_4pzcwl_11(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_11(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var defaults$$inlined$viewForType$11Class;
function defaults$$inlined$viewForType$11() {
  if (defaults$$inlined$viewForType$11Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.ieg_1 = $size;
        this.deg_1 = $annotation;
        this.eeg_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.feg_1 = $serializer.az().l11();
        this.geg_1 = $name;
        this.heg_1 = $priority;
      }
      qdu() {
        return this.deg_1;
      }
      f94() {
        return this.eeg_1;
      }
      pdu() {
        return this.feg_1;
      }
      k20() {
        return this.geg_1;
      }
      cdu() {
        return this.heg_1;
      }
      idu(module_0, selector) {
        return this.ieg_1;
      }
      ndu(module_0, selector) {
        var tmp = Companion_instance_0;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.odu(module_0, this, tmp_0, VOID, VOID, defaults$o$view$lambda_11);
        return isInterface(tmp_1, ViewRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator_0()]);
    defaults$$inlined$viewForType$11Class = $;
  }
  return defaults$$inlined$viewForType$11Class;
}
function defaults$o$view$lambda_12($this$ViewRenderer, field, readable) {
  var prop = readable;
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())($this$ViewRenderer.pc());
  var tmp0_elvis_lhs = $this$ViewRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$ViewRenderer : tmp0_elvis_lhs;
  $this$ViewRenderer.ebb(p, view);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl_12(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_12(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var tmp$ret$0 = renderToString_2($this$reactiveScope.baj(prop));
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  $this$ViewRenderer.fbb(p, view);
  return view;
}
function TextView$_get_content_$ref_4pzcwl_12(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_12(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var defaults$$inlined$viewForType$12Class;
function defaults$$inlined$viewForType$12() {
  if (defaults$$inlined$viewForType$12Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.oeg_1 = $size;
        this.jeg_1 = $annotation;
        this.keg_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.leg_1 = $serializer.az().l11();
        this.meg_1 = $name;
        this.neg_1 = $priority;
      }
      qdu() {
        return this.jeg_1;
      }
      f94() {
        return this.keg_1;
      }
      pdu() {
        return this.leg_1;
      }
      k20() {
        return this.meg_1;
      }
      cdu() {
        return this.neg_1;
      }
      idu(module_0, selector) {
        return this.oeg_1;
      }
      ndu(module_0, selector) {
        var tmp = Companion_instance_0;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.odu(module_0, this, tmp_0, VOID, VOID, defaults$o$view$lambda_12);
        return isInterface(tmp_1, ViewRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator_0()]);
    defaults$$inlined$viewForType$12Class = $;
  }
  return defaults$$inlined$viewForType$12Class;
}
function defaults$o$form$lambda_49($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp$ret$0 = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  return $this$FormRenderer.jbb(tmp$ret$0, defaults$temperatureInput($this$FormRenderer, mutable));
}
var defaults$$inlined$formForType$50Class;
function defaults$$inlined$formForType$50() {
  if (defaults$$inlined$formForType$50Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.ueg_1 = $size;
        this.peg_1 = $annotation;
        this.qeg_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.reg_1 = $serializer.az().l11();
        this.seg_1 = $name;
        this.teg_1 = $priority;
      }
      qdu() {
        return this.peg_1;
      }
      f94() {
        return this.qeg_1;
      }
      pdu() {
        return this.reg_1;
      }
      k20() {
        return this.seg_1;
      }
      cdu() {
        return this.teg_1;
      }
      idu(module_0, selector) {
        return this.ueg_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_49);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$50Class = $;
  }
  return defaults$$inlined$formForType$50Class;
}
function defaults$o$form$lambda_50($this$FormRenderer, field, mutable) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp$ret$0 = $this$FormRenderer.hbb(FieldSemantic_getInstance());
  return $this$FormRenderer.jbb(tmp$ret$0, defaults$temperatureInput($this$FormRenderer, nullable(mutable)));
}
var defaults$$inlined$formForType$51Class;
function defaults$$inlined$formForType$51() {
  if (defaults$$inlined$formForType$51Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.aeh_1 = $size;
        this.veg_1 = $annotation;
        this.weg_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.xeg_1 = $serializer.az().l11();
        this.yeg_1 = $name;
        this.zeg_1 = $priority;
      }
      qdu() {
        return this.veg_1;
      }
      f94() {
        return this.weg_1;
      }
      pdu() {
        return this.xeg_1;
      }
      k20() {
        return this.yeg_1;
      }
      cdu() {
        return this.zeg_1;
      }
      idu(module_0, selector) {
        return this.aeh_1;
      }
      ldu(module_0, selector) {
        var tmp = Companion_instance_1;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.mdu(module_0, this, tmp_0, VOID, VOID, defaults$o$form$lambda_50);
        return isInterface(tmp_1, FormRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator()]);
    defaults$$inlined$formForType$51Class = $;
  }
  return defaults$$inlined$formForType$51Class;
}
function defaults$o$view$lambda_13($this$ViewRenderer, field, readable) {
  var it = readable;
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())($this$ViewRenderer.pc());
  var tmp0_elvis_lhs = $this$ViewRenderer.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$ViewRenderer : tmp0_elvis_lhs;
  $this$ViewRenderer.ebb(p, view);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl_13(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_13(view));
  reactiveScope(view, ($this$reactiveScope) => {
    var tmp$ret$0 = toString_1($this$reactiveScope.baj(it));
    this_0.set(tmp$ret$0);
    return Unit_instance;
  });
  $this$ViewRenderer.fbb(p, view);
  return view;
}
function TextView$_get_content_$ref_4pzcwl_13(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_13(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var defaults$$inlined$viewForType$13Class;
function defaults$$inlined$viewForType$13() {
  if (defaults$$inlined$viewForType$13Class === VOID) {
    class $ {
      constructor($annotation, $serializer, $name, $priority, $size) {
        this.geh_1 = $size;
        this.beh_1 = $annotation;
        this.ceh_1 = substringBefore(get_nonNullOriginal($serializer.az()).h10(), _Char___init__impl__6a9atx(47));
        this.deh_1 = $serializer.az().l11();
        this.eeh_1 = $name;
        this.feh_1 = $priority;
      }
      qdu() {
        return this.beh_1;
      }
      f94() {
        return this.ceh_1;
      }
      pdu() {
        return this.deh_1;
      }
      k20() {
        return this.eeh_1;
      }
      cdu() {
        return this.feh_1;
      }
      idu(module_0, selector) {
        return this.geh_1;
      }
      ndu(module_0, selector) {
        var tmp = Companion_instance_0;
        var tmp_0 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_1 = tmp.odu(module_0, this, tmp_0, VOID, VOID, defaults$o$view$lambda_13);
        return isInterface(tmp_1, ViewRenderer()) ? tmp_1 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).uds = get_handlesField;
    protoOf($).rdu = priority;
    protoOf($).ddu = matches;
    initMetadataForClass($, VOID, VOID, VOID, [Generator_0()]);
    defaults$$inlined$viewForType$13Class = $;
  }
  return defaults$$inlined$viewForType$13Class;
}
function *_generator_invoke__zhh2q8_1($this, $this$withWrite, it, $completion) {
  var tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ieh_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  if (tmp_0) {
    tmp = it == null ? null : Companion_instance.r4w(it);
  } else {
    tmp = it == null ? null : Companion_instance.s4w(it);
  }
  var tmp_1 = tmp;
  var tmp_2 = $this.heh_1.gah(tmp_1 == null ? null : new (Temperature())(tmp_1), $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
var defaults$temperatureInput$slambdaClass;
function defaults$temperatureInput$slambda() {
  if (defaults$temperatureInput$slambdaClass === VOID) {
    class $ {
      constructor($mutable, $celsius) {
        this.heh_1 = $mutable;
        this.ieh_1 = $celsius;
      }
      jeh($this$withWrite, it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$withWrite, it), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Reactive()) : false) ? p1 : THROW_CCE();
        return this.jeh(tmp, (p2 == null ? true : typeof p2 === 'number') ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    defaults$temperatureInput$slambdaClass = $;
  }
  return defaults$temperatureInput$slambdaClass;
}
function defaults$temperatureInput$slambda_0($mutable, $celsius) {
  var i = new (defaults$temperatureInput$slambda())($mutable, $celsius);
  var l = ($this$withWrite, it, $completion) => i.jeh($this$withWrite, it, $completion);
  l.$arity = 2;
  return l;
}
function defaults$temperatureInput$lambda(it) {
  return it ? '\xB0C' : '\xB0F';
}
//region block: exports
export {
  defaults as defaults3uorosiarf5y,
};
//endregion

//# sourceMappingURL=builtinRenderers.mjs.map
